/**
 * 매뉴얼 문구 — `landing` 네임스페이스의 `site.manual` 로 합쳐진다(service-manual: 매뉴얼 문구의 출처).
 * 꾸밈: `<ui>…</ui>` 화면의 단추·칸 이름, `<a href="#t-…">…</a>` 다른 절로 가는 링크. 절 구조·안내 화면 좌표는
 * `Home/Manual/manualTopics.ts`·`manualGuides.ts` 에 있다.
 */
const landingManual = {
  "eyebrow": "សៀវភៅណែនាំ",
  "title": "រៀនប្រើ DroneSquare តាមវីដេអូ",
  "searchLabel": "ស្វែងរកក្នុងសៀវភៅណែនាំ",
  "searchPlaceholder": "បញ្ចូលមុខងារដែលចង់ស្វែងរក (ឧ. ការធ្វើផែនទី, ផ្នែកឆ្លង)",
  "searchEmpty": "រកមិនឃើញមុខងារនេះទេ។ សូមសាកស្វែងរកដោយពាក្យផ្សេង។",
  "searchCount": "រកឃើញ {{count}} ប្រធានបទ។",
  "chaptersLabel": "ការណែនាំតាមមុខងារ",
  "jumpLabel": "ទៅកាន់ជំពូកនៃសៀវភៅណែនាំ",
  "tocLabel": "បញ្ជីប្រធានបទនៃ {{chapter}}",
  "allChapters": "មាតិកាទាំងមូល",
  "backToStart": "ត្រឡប់ទៅដើម",
  "gate": {
    "title": "សៀវភៅណែនាំ និងវីដេអូបង្ហាញអាចមើលបានបន្ទាប់ពីចូលប្រព័ន្ធ",
    "text": "ចូលប្រព័ន្ធដោយគណនី DroneSquare ឬប្រសិនបើមិនទាន់មានគណនី សូមប្រាប់យើងតាមរយៈការសាកសួរ 1:1។",
    "login": "ចូលប្រព័ន្ធ",
    "inquiry": "សាកសួរ 1:1"
  },
  "noteLabel": {
    "note": "ចំណាំ",
    "caution": "ប្រយ័ត្ន"
  },
  "player": {
    "label": "ការណែនាំតាមជំហាន៖ {{title}}",
    "stepsLabel": "ទៅកាន់ជំហាន",
    "step": "ជំហានទី {{n}}៖ {{title}}",
    "prev": "ជំហានមុន៖ {{title}}",
    "next": "ជំហានបន្ទាប់៖ {{title}}",
    "play": "ចាក់",
    "pause": "ផ្អាក"
  },
  "chapters": {
    "c1": {
      "name": "គម្រោង",
      "subtitle": "គ្រប់គ្រងគម្រោង និងថ្ងៃថត"
    },
    "c2": {
      "name": "រូបភាព·ការធ្វើផែនទី",
      "subtitle": "ផ្ទុករូបថតឡើង ហើយធ្វើជាផែនទី"
    },
    "c3": {
      "name": "ទិន្នន័យយោង·ស្រទាប់",
      "subtitle": "ផ្ទុកប្លង់ និងឯកសារឡើងជាមួយគ្នា"
    },
    "c4": {
      "name": "ការត្រួតពិនិត្យ 2D",
      "subtitle": "ពិនិត្យការដ្ឋានដោយរូបភាព Ortho",
      "open": "ការត្រួតពិនិត្យ 2D៖ ចុច <ui>ត្រួតពិនិត្យស៊េរីពេលវេលា</ui> ក្នុងម៉ឺនុយតារាងរងនៃថ្ងៃថតដែលដំណើរការរួច ឬចុច <ui>2d3d</ui> នៅរបារខាងឆ្វេង ដើម្បីបើក។"
    },
    "c5": {
      "name": "ការត្រួតពិនិត្យ 3D",
      "subtitle": "ត្រួតពិនិត្យការដ្ឋានដោយម៉ូដែល 3D",
      "open": "ការត្រួតពិនិត្យ 3D៖ ចុច <ui>3D</ui> នៅលើរបារ ដើម្បីបើកម៉ូដែល 3D នៃថ្ងៃថតដដែល។ បើ 3D មិនទាន់បានបង្កើតទេ នឹងបង្ហាញ [3D (mesh) មិនទាន់បានបង្កើតនៅឡើយទេ]។"
    },
    "c6": {
      "name": "ក្រាហ្វផ្នែកកាត់",
      "subtitle": "មើលផ្នែកកាត់បណ្ដោយ និងទទឹង"
    },
    "c7": {
      "name": "ការតាមដានការដ្ឋាន",
      "subtitle": "តាមដានកម្មករ និងឧបករណ៍នៅលើផែនទី",
      "open": "ការតាមដានការដ្ឋាន៖ ចូលតាម <ui>worksite</ui> នៅលើរបារនៃបញ្ជីគម្រោង។ ត្រូវមានថ្ងៃថតដែលដំណើរការ 2D ឬ 3D រួចយ៉ាងហោចណាស់មួយ ទើបអាចបើកបាន។"
    },
    "c8": {
      "name": "ការងារដី",
      "subtitle": "គណនាការងារដីតាមតំបន់ និងខ្សែបន្ទាត់",
      "open": "ការងារដី៖ បើគម្រោងមានប្លង់ការដ្ឋាន ឬស្រទាប់លីនេអ៊ែរ ហើយមានថ្ងៃថតដែលដំណើរការរួច អាចចូលតាម <ui>earthwork</ui> នៅលើរបារ។"
    }
  },
  "topics": {
    "t-new": {
      "title": "បង្កើតគម្រោងថ្មី",
      "note": "[ច្រោះ] ក្នុងបញ្ជីច្រោះតាមស្លាកប៉ុណ្ណោះ ដូច្នេះសូមភ្ជាប់ក្រុមដែលចង់ស្វែងរកនៅពេលក្រោយជាស្លាក។ បើបិទប្រអប់ ខ្លឹមសារដែលបានបញ្ចូលនឹងបាត់។ ទីតាំង·ឈ្មោះ·ប្រភេទ·ស្លាក·កំណត់ចំណាំ អាចប្ដូរបាននៅពេលក្រោយក្នុង <a href=\"#t-edit\">កែសម្រួលព័ត៌មានគម្រោង</a>។",
      "steps": [
        {
          "title": "ចុច [បង្កើតគម្រោងថ្មី]",
          "caption": "ចុច [បង្កើតគម្រោងថ្មី] នៅខាងស្ដាំលើ។"
        },
        {
          "title": "ចាប់ផ្ដើមជំហានទីតាំង",
          "caption": "ប្រអប់ [បន្ថែមគម្រោង] បើកឡើង។ ជំហានទី 1 ទីតាំង៖ ស្វែងរកអាសយដ្ឋាន ឬចុចលើផែនទី។"
        },
        {
          "title": "ជ្រើសអាសយដ្ឋានការដ្ឋាន",
          "caption": "ពេលលទ្ធផលស្វែងរកបង្ហាញ សូមជ្រើសអាសយដ្ឋានការដ្ឋាន។"
        },
        {
          "title": "ពិនិត្យទីតាំង ហើយ [បន្ទាប់]",
          "caption": "ផែនទីផ្លាស់ទៅទីតាំងនោះ ហើយកាតខាងក្រោមបង្ហាញអាសយដ្ឋាន និងរយៈទទឹង·រយៈបណ្ដោយ។ ចុច [បន្ទាប់]។"
        },
        {
          "title": "បញ្ចូលព័ត៌មានគម្រោង",
          "caption": "ជំហានទី 2 ព័ត៌មានគម្រោង៖ បញ្ចូលឈ្មោះគម្រោង ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ ប្រភេទវត្ថុ ស្លាក និងកំណត់ចំណាំ។"
        },
        {
          "title": "បើក [ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ]",
          "caption": "បានបញ្ចូលឈ្មោះគម្រោងហើយ។ ជ្រើស [ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ]។"
        },
        {
          "title": "ជ្រើសថ្នាក់វត្ថុ",
          "caption": "ជ្រើសពីវត្ថុទូទៅ·ច្រករបៀង·ផ្ទៃ·បញ្ឈរ។ [ផ្សេងៗ] ត្រូវបញ្ចូលដោយខ្លួនឯង។"
        },
        {
          "title": "បញ្ចូល [ប្រភេទវត្ថុ]",
          "caption": "បញ្ចូល [ប្រភេទវត្ថុ]។"
        },
        {
          "title": "សរសេរស្លាក·កំណត់ចំណាំ ហើយ [បន្ទាប់]",
          "caption": "ស្លាក·កំណត់ចំណាំ ជាជម្រើស។ ចុច [បន្ទាប់]។"
        },
        {
          "title": "បើកប្រអប់ថ្ងៃថត",
          "caption": "ជំហានទី 3 បន្ថែមស៊េរីពេលវេលា៖ ចុចប្រអប់ថ្ងៃថត ហើយជ្រើសថ្ងៃថតដំបូង។"
        },
        {
          "title": "ជ្រើសកាលបរិច្ឆេទក្នុងប្រតិទិន",
          "caption": "ជ្រើសកាលបរិច្ឆេទក្នុងប្រតិទិន។"
        },
        {
          "title": "បង្កើតដោយ [បន្ថែម]",
          "caption": "ថ្ងៃថតត្រូវបានបំពេញហើយ។ ចុច [បន្ថែម] ដើម្បីបង្កើតគម្រោង។"
        },
        {
          "title": "ពិនិត្យការបង្កើតរួចរាល់",
          "caption": "សារជូនដំណឹង [ការបង្កើតគម្រោងបានជោគជ័យ] បង្ហាញ ហើយត្រឡប់ទៅបញ្ជីវិញ។"
        }
      ]
    },
    "t-edit": {
      "title": "កែសម្រួលព័ត៌មានគម្រោង",
      "note": "ថ្ងៃថត និងកំណត់ចំណាំថ្ងៃថត កែនៅ <a href=\"#t-series\">បន្ថែម·កែ·លុបស៊េរីពេលវេលា</a> មិនមែនក្នុងប្រអប់នេះទេ។",
      "steps": [
        {
          "title": "ជ្រើសគម្រោង",
          "caption": "ក្នុងបញ្ជី ចុចគម្រោងដែលចង់កែ។"
        },
        {
          "title": "ចុច [កែ]",
          "caption": "ចុច [កែ] នៅក្បែរ [ព័ត៌មានលម្អិត] ក្នុងផ្ទាំង [ព័ត៌មាន] ខាងស្ដាំ។"
        },
        {
          "title": "កែប្រអប់ដែលត្រូវកែ",
          "caption": "ប្រអប់ [កែសម្រួលព័ត៌មានគម្រោង] បើកឡើង។ កែឈ្មោះ·ប្រភេទ·ស្លាក·កំណត់ចំណាំ ដែលត្រូវកែ។"
        },
        {
          "title": "ចុច [រក្សាទុក]",
          "caption": "បន្ទាប់ពីកែ ចុច [រក្សាទុក]។ [កំណត់ឡើងវិញ] ត្រឡប់ទៅតម្លៃដើម។"
        },
        {
          "title": "ពិនិត្យការកែរួចរាល់",
          "caption": "សារជូនដំណឹង [ព័ត៌មានគម្រោងបានធ្វើបច្ចុប្បន្នភាព] បង្ហាញ ហើយព័ត៌មានលម្អិតត្រូវបានធ្វើបច្ចុប្បន្នភាពភ្លាមៗ។"
        }
      ]
    },
    "t-series": {
      "title": "បន្ថែម·កែ·លុបស៊េរីពេលវេលា",
      "note": "មានតែម្ចាស់គម្រោងប៉ុណ្ណោះដែលអាចបន្ថែម·កែថ្ងៃថតបាន។",
      "steps": [
        {
          "title": "ចុច [បន្ថែមស៊េរីពេលវេលា]",
          "caption": "ចុច [បន្ថែមស៊េរីពេលវេលា] ក្នុងតារាង។"
        },
        {
          "title": "បើកប្រអប់ថ្ងៃថត",
          "caption": "នេះជាប្រអប់ [បន្ថែមស៊េរីពេលវេលា]។ ចុចប្រអប់ថ្ងៃថត ហើយជ្រើសកាលបរិច្ឆេទ។"
        },
        {
          "title": "ជ្រើសថ្ងៃថតក្នុងប្រតិទិន",
          "caption": "ជ្រើសថ្ងៃថតក្នុងប្រតិទិន។ មិនអាចបង្កើតកាលបរិច្ឆេទដែលមានរួចហើយបានទេ។"
        },
        {
          "title": "បញ្ចូលកំណត់ចំណាំ",
          "caption": "ថ្ងៃថតត្រូវបានបញ្ចូលហើយ។ សរសេរការពិពណ៌នាវគ្គនេះក្នុងប្រអប់កំណត់ចំណាំ។"
        },
        {
          "title": "ចុច [បញ្ចប់]",
          "caption": "បញ្ចូលកំណត់ចំណាំ ហើយចុច [បញ្ចប់]។"
        },
        {
          "title": "ពង្រីកបញ្ជីថ្ងៃថត",
          "caption": "ថ្ងៃថតថ្មីត្រូវបានបន្ថែម។ ចុចព្រួញខាងឆ្វេងជួរគម្រោង ដើម្បីពង្រីកបញ្ជីថ្ងៃថត។"
        },
        {
          "title": "ជ្រើសថ្ងៃថតដែលចង់កែ",
          "caption": "ជួរថ្ងៃថតថ្មីបង្ហាញឡើង។ ចុចថ្ងៃថតដែលចង់កែ។"
        },
        {
          "title": "ចុច [កែ]",
          "caption": "ចុច [កែ] នៅក្បែរ [$t(projects:timeSeries.mappingInfo)] ក្នុងផ្ទាំង [ព័ត៌មាន] ខាងស្ដាំ។"
        },
        {
          "title": "កែកំណត់ចំណាំ",
          "caption": "ក្នុងប្រអប់ [កែស៊េរីពេលវេលា] កែថ្ងៃថត និងកំណត់ចំណាំ។"
        },
        {
          "title": "ចុច [រក្សាទុក]",
          "caption": "កំណត់ចំណាំត្រូវបានកែ។ ចុច [រក្សាទុក]។"
        },
        {
          "title": "ចុចធុងសំរាម",
          "caption": "សារជូនដំណឹង [ព័ត៌មានស៊េរីពេលវេលាបានធ្វើបច្ចុប្បន្នភាព] បង្ហាញ។ ដើម្បីលុប ចុចធុងសំរាមនៅជួរនោះ។"
        },
        {
          "title": "បញ្ចូលកាលបរិច្ឆេទឱ្យដូចគ្នា",
          "caption": "នេះជាប្រអប់ [លុបស៊េរីពេលវេលា]។ បញ្ចូលកាលបរិច្ឆេទនោះឱ្យដូចគ្នាក្នុងប្រអប់បញ្ជាក់។"
        },
        {
          "title": "ចុច [លុប]",
          "caption": "[លុប] អាចចុចបាន លុះត្រាតែកាលបរិច្ឆេទដូចគ្នា។ ថ្ងៃថតដែលបានលុប មិនអាចស្ដារវិញបានទេ។"
        },
        {
          "title": "ពិនិត្យការលុបរួចរាល់",
          "caption": "សារជូនដំណឹង [ការលុបបានជោគជ័យ។] បង្ហាញ ហើយថ្ងៃថតនោះបាត់ពីបញ្ជី។"
        }
      ]
    },
    "t-list": {
      "title": "បញ្ជីគម្រោង",
      "note": "ផ្ទាំង [រូបភាពដ្រូន] បង្ហាញតែពេលជ្រើសថ្ងៃថតប៉ុណ្ណោះ។",
      "steps": [
        {
          "title": "ស្វែងរកតាមឈ្មោះ",
          "caption": "ពេលចូលគណនី បញ្ជីគម្រោងបើកឡើង។ បញ្ចូលផ្នែកខ្លះនៃឈ្មោះក្នុងប្រអប់ស្វែងរក។"
        },
        {
          "title": "លុបពាក្យស្វែងរក",
          "caption": "បន្តិចក្រោយមក នៅសល់តែគម្រោងដែលឈ្មោះត្រូវគ្នា។ លុបពាក្យស្វែងរក ដើម្បីត្រឡប់ទៅបញ្ជីទាំងមូល។"
        },
        {
          "title": "បើក [ច្រោះ]",
          "caption": "ពីបញ្ជីទាំងមូល ចុច [ច្រោះ] ដើម្បីបង្រួមតាមស្លាក។"
        },
        {
          "title": "ជ្រើសស្លាក",
          "caption": "គូសធីកស្លាកដែលចង់រក។ លេខនៅក្បែរ គឺចំនួនគម្រោងដែលមានស្លាកនោះ។"
        },
        {
          "title": "ចុច [អនុវត្ត]",
          "caption": "ចុច [អនុវត្ត]។ [ដំណើរការឡើងវិញ] ដោះការគូសធីកទាំងអស់។"
        },
        {
          "title": "ជ្រើសគម្រោង",
          "caption": "នៅសល់តែគម្រោងដែលមានស្លាកនោះក្នុងតារាង និងលើផែនទី។ ចុចគម្រោង។"
        },
        {
          "title": "ប្ដូរផ្ទាំងទិន្នន័យ",
          "caption": "ផែនទីផ្លាស់ទៅទីតាំងនោះ ហើយផ្ទាំងព័ត៌មានលម្អិតបង្ហាញនៅខាងក្រោម។ ចុចផ្ទាំង [ទិន្នន័យស្រទាប់]។"
        },
        {
          "title": "មើលទិន្នន័យក្នុងផ្ទាំង",
          "caption": "ប្ដូរផ្ទាំង ដើម្បីមើលទិន្នន័យរបស់គម្រោងនោះ។"
        }
      ]
    },
    "t-member": {
      "title": "សមាជិក និងសិទ្ធិ",
      "steps": [
        {
          "title": "បើកប្រវត្តិរូប",
          "caption": "ចុចប្រវត្តិរូបនៅខាងក្រោមរបារខាងឆ្វេង។"
        },
        {
          "title": "បើក [គ្រប់គ្រងសិទ្ធិគម្រោង]",
          "caption": "ទំព័ររបស់ខ្ញុំបើកឡើង។ ចុច [គ្រប់គ្រងសិទ្ធិគម្រោង]។"
        },
        {
          "title": "ជ្រើសគម្រោង ហើយ [បន្ថែមសមាជិក]",
          "caption": "ក្នុង [ជ្រើសរើសគម្រោង] ជ្រើសគម្រោងដែលអ្នកជាម្ចាស់ នោះបញ្ជីសមាជិកនឹងបង្ហាញ។ ចុច [បន្ថែមសមាជិក]។"
        },
        {
          "title": "បញ្ចូលអ៊ីមែល",
          "caption": "បញ្ចូលអ៊ីមែលរបស់អ្នកដែលត្រូវអញ្ជើញ។"
        },
        {
          "title": "ចុច [បន្ថែម]",
          "caption": "បញ្ចូលអ៊ីមែល ហើយចុច [បន្ថែម]។"
        },
        {
          "title": "ប្ដូរតួនាទី",
          "caption": "[បានបន្ថែមអ្នកប្រើ] បង្ហាញឡើង ហើយសមាជិកថ្មីលេចឡើងក្នុងបញ្ជី។ ជ្រើសតួនាទី។"
        },
        {
          "title": "ចុច [រក្សាទុក]",
          "caption": "ពេលប្ដូរតួនាទី [រក្សាទុក] ខាងក្រោមអាចចុចបាន។ ត្រូវចុច [រក្សាទុក] ទើបការផ្លាស់ប្ដូរមានប្រសិទ្ធភាព។"
        },
        {
          "title": "ពិនិត្យការរក្សាទុករួចរាល់",
          "caption": "[សិទ្ធិបានធ្វើបច្ចុប្បន្នភាព] បង្ហាញឡើង។"
        }
      ]
    },
    "t-history": {
      "title": "ប្រវត្តិគម្រោង",
      "note": "រំកិលដល់ចុងបញ្ជី ដើម្បីផ្ទុកកំណត់ត្រាចាស់ៗបន្ថែម។ ម៉ោងបង្ហាញតាម <a href=\"#t-lang\">តំបន់ពេលវេលា</a>។",
      "steps": [
        {
          "title": "បើកប្រវត្តិរូប",
          "caption": "ប្រវត្តិគម្រោងប្រមូលបង្ហាញថា នរណាបានបន្ថែម កែ ឬលុបអ្វី និងនៅពេលណា តាមគម្រោងនីមួយៗ។ ចុចប្រវត្តិរូបនៅខាងក្រោមរបារខាងឆ្វេង។"
        },
        {
          "title": "បើក [ប្រវត្តិគម្រោង]",
          "caption": "ទំព័ររបស់ខ្ញុំបើកឡើង។ ចុច [ប្រវត្តិគម្រោង]។"
        },
        {
          "title": "ចុច [ច្រោះ]",
          "caption": "កំណត់ត្រានៃគម្រោងដែលបានជ្រើសក្នុង [ជ្រើសរើសគម្រោង] បង្ហាញតាមថ្ងៃ ថ្មីបំផុតមុន។ កំណត់ត្រាដែលកើតពីស៊េរីពេលវេលា មានថ្ងៃថតនៅខាងស្ដាំ។ ចុច [ច្រោះ]។"
        },
        {
          "title": "ជ្រើស [ចំណាំ]",
          "caption": "ប្រភេទកំណត់ត្រាបង្ហាញឡើង។ ជ្រើស [ចំណាំ]។"
        },
        {
          "title": "មើលកំណត់ត្រាចំណាំ",
          "caption": "នៅសល់តែកំណត់ត្រានៃការបន្ថែម កែ និងលុបចំណាំប៉ុណ្ណោះ។"
        }
      ]
    },
    "t-lang": {
      "title": "ភាសា និងតំបន់ពេលវេលា",
      "note": "ភាសាដែលបានជ្រើសត្រូវបានរក្សាទុកក្នុងកម្មវិធីរុករកនេះ ហើយនៅដដែលពេលបើកលើកក្រោយ។ តំបន់ពេលវេលាគ្មានកន្លែងប្ដូរទេ វាធ្វើតាមតំបន់ពេលវេលារបស់កម្មវិធីរុករក ហើយម៉ោងក្នុង <a href=\"#t-history\">ប្រវត្តិគម្រោង</a> ក៏បង្ហាញតាមនេះដែរ។",
      "steps": [
        {
          "title": "ចុចប៊ូតុងភាសា",
          "caption": "អាចជ្រើសភាសាអេក្រង់ជា កូរ៉េ អង់គ្លេស ជប៉ុន ឬខ្មែរ។ ចុច [ko] ដែលបង្ហាញភាសាបច្ចុប្បន្ន នៅខាងក្រោមរបារខាងឆ្វេង។"
        },
        {
          "title": "ជ្រើស [日本語]",
          "caption": "ភាសាទាំងបួនបង្ហាញឡើង។ នៅទីនេះ ជ្រើស [日本語]។ សម្រាប់ភាសាខ្មែរ ជ្រើស [ខ្មែរ]។"
        },
        {
          "title": "បើកប្រវត្តិរូប",
          "caption": "ម៉ឺនុយ និងប៊ូតុងប្ដូរទៅជាភាសាជប៉ុន ហើយប៊ូតុងភាសាក្លាយជា [ja]។ ចុចប្រវត្តិរូប ដើម្បីមើលតំបន់ពេលវេលា។"
        },
        {
          "title": "ពិនិត្យតំបន់ពេលវេលា",
          "caption": "ក្នុងទំព័ររបស់ខ្ញុំ តំបន់ពេលវេលា ([表示タイムゾーン]) ក្រោមព័ត៌មានគណនី ([アカウント情報]) ត្រូវបានកំណត់ដោយស្វ័យប្រវត្តិតាមតំបន់ពេលវេលារបស់កម្មវិធីរុករក។"
        }
      ]
    },
    "t-upload": {
      "title": "ផ្ទុករូបភាពដ្រូនឡើង",
      "note": "រូបថតដែលមានឈ្មោះឯកសារដូចគ្នា ផ្ទុកឡើងបានតែមួយ ទោះនៅក្នុងថតផ្សេងគ្នាក៏ដោយ ដូច្នេះសូមកុំឱ្យឈ្មោះរូបថតពីការហោះហើរផ្សេងៗជាន់គ្នា។",
      "steps": [
        {
          "title": "បើកផ្ទាំង [រូបភាពដ្រូន]",
          "caption": "ពេលជ្រើសគម្រោង និងថ្ងៃថត ព័ត៌មានលម្អិតបើកនៅខាងក្រោម។ ចុចផ្ទាំង [រូបភាពដ្រូន]។"
        },
        {
          "title": "ចុច [បន្ថែមរូបភាព]",
          "caption": "រូបថតដែលបានផ្ទុកឡើង បង្ហាញក្នុង [បញ្ជីបញ្ចូលបានបញ្ចប់]។ ចុច [បន្ថែមរូបភាព]។"
        },
        {
          "title": "ជ្រើសរូបថតដោយ [ជ្រើសរើសឯកសារ]",
          "caption": "អូសទម្លាក់ឯកសារ .jpg·.jpeg ឬជ្រើសដោយ [ជ្រើសរើសឯកសារ]។"
        },
        {
          "title": "ចុច [បញ្ចូលរូបភាព]",
          "caption": "ចំនួនរូបភាពដែលត្រូវបញ្ចូល និងទំហំសរុបបង្ហាញឡើង។ ចុច [បញ្ចូលរូបភាព]។"
        },
        {
          "title": "ពិនិត្យការផ្ទុកឡើងរួចរាល់",
          "caption": "[ការបញ្ចូលរូបភាពបានបញ្ចប់ដោយជោគជ័យ។] បង្ហាញ ហើយរូបថតដែលបានផ្ទុកឡើងលេចឡើងក្នុង [បញ្ជីបញ្ចូលបានបញ្ចប់]។"
        }
      ]
    },
    "t-mapping": {
      "title": "ស្នើសុំការធ្វើផែនទី និង GCP",
      "steps": [
        {
          "title": "ចុច [បញ្ចូល GCP]",
          "caption": "ជ្រើសថ្ងៃថត ហើយមើល [$t(projects:timeSeries.mappingInfo)] ក្នុងផ្ទាំង [ព័ត៌មាន]។ ចុច [បញ្ចូល GCP] ជាមុនសិន។"
        },
        {
          "title": "បើក [$t(projects:timeSeries.gcpAutoDetect)]",
          "caption": "ពេលជ្រើសឯកសារ GCP ($t(projects:timeSeries.gcpGuide.readableFormats)) ឈ្មោះឯកសារបង្ហាញនៅជួរ GCP។"
        },
        {
          "title": "បើកមគ្គុទ្ទេសក៍$t(projects:timeSeries.gcpAutoDetect)",
          "caption": "បើបានដាក់សញ្ញាសម្គាល់ស្តង់ដារ ហើយថត សូមបើក [$t(projects:timeSeries.gcpAutoDetect)]។ [?] ខាងស្ដាំ គឺមគ្គុទ្ទេសក៍$t(projects:timeSeries.gcpAutoDetect)។"
        },
        {
          "title": "បិទមគ្គុទ្ទេសក៍",
          "caption": "ពិនិត្យលក្ខខណ្ឌ និងឯកសារបោះពុម្ពសញ្ញាសម្គាល់ ក្នុង [$t(projects:timeSeries.gcpGuide.title)]។ ចុចបិទ។"
        },
        {
          "title": "ចុច [សំណើការគូសផែនទី]",
          "caption": "ចុច [សំណើការគូសផែនទី]។"
        },
        {
          "title": "បញ្ជាក់ដោយ [ស្នើសុំ]",
          "caption": "នេះជាប្រអប់បញ្ជាក់។ បន្ទាប់ពីស្នើសុំ មិនអាចផ្ទុករូបភាពបន្ថែម ឬលុបបានទេ។ ចុច [ស្នើសុំ]។"
        },
        {
          "title": "ពិនិត្យការស្នើសុំរួចរាល់",
          "caption": "[ការស្នើសុំការគូសផែនទីបានបញ្ចប់។] បង្ហាញ ហើយប៊ូតុងប្ដូរទៅជា [សំណើបានបញ្ចប់]។"
        }
      ]
    },
    "t-download": {
      "title": "ទាញយកលទ្ធផល",
      "note": "បើត្រូវការតម្លៃកម្ពស់ សូមប្រើចំណុចកម្ពស់ក្នុងកញ្ចប់ CAD ជំនួសឱ្យ DSM GeoTIFF។",
      "steps": [
        {
          "title": "ចុច [បង្កើត]",
          "caption": "នេះជាប្រអប់ [ទាញយក] នៅខាងស្ដាំ [$t(projects:timeSeries.mappingInfo)] នៃថ្ងៃថតដែលដំណើរការរួច។ គុណភាពនីមួយៗមាន [បង្កើត] ឬ [ទាញយក]។"
        },
        {
          "title": "ចុច [ទាញយក]",
          "caption": "ពេលចុច [បង្កើត] បន្ទាប់ពី [កំពុងបង្កើត N%] បញ្ចប់ វាប្ដូរទៅជា [ទាញយក]។"
        },
        {
          "title": "យល់ព្រមប្រអប់បញ្ជាក់",
          "caption": "ឯកសារធំលើស 1 GB ត្រូវឆ្លងកាត់ប្រអប់ [បញ្ជាក់ការទាញយក] ម្ដងទៀត។"
        }
      ]
    },
    "t-layerdata": {
      "title": "ទិន្នន័យស្រទាប់",
      "note": "ស្រទាប់ដែលបានផ្ទុកឡើង បើក និងបិទនៅផ្ទាំង <ui>LAYER</ui> នៃអេក្រង់ 2D·3D។",
      "steps": [
        {
          "title": "បើកផ្ទាំង [ទិន្នន័យស្រទាប់]",
          "caption": "ជ្រើសគម្រោង ហើយចុចផ្ទាំង [ទិន្នន័យស្រទាប់]។"
        },
        {
          "title": "ចុចរូបតំណាងផ្ទុកឡើង",
          "caption": "មានប្រអប់ GIS·ស្រទាប់បន្ទាត់·BIM·Point Cloud។ ចុចរូបតំណាងផ្ទុកឡើងនៅក្បាលប្រអប់។"
        },
        {
          "title": "ពិនិត្យការផ្ទុកឡើងរួចរាល់",
          "caption": "ការជូនដំណឹងថាផ្ទុកឡើងរួចរាល់ បង្ហាញនៅខាងស្ដាំលើ ហើយឯកសារលេចឡើងក្នុងប្រអប់ GIS។"
        }
      ]
    },
    "t-terrain": {
      "title": "ទិន្នន័យកម្ពស់ភូមិសាស្ត្រ",
      "note": "តារាងបរិមាណផ្នែកឆ្លង អាចមើលបានលុះត្រាតែមានទាំងដីដើម និងកម្ពស់គម្រោង។",
      "steps": [
        {
          "title": "បើកផ្ទាំង [ទិន្នន័យកម្ពស់ភូមិសាស្ត្រ]",
          "caption": "ជ្រើសគម្រោង ហើយចុចផ្ទាំង [ទិន្នន័យកម្ពស់ភូមិសាស្ត្រ]។"
        },
        {
          "title": "ចុចរូបតំណាងផ្ទុកឡើង",
          "caption": "មានប្រអប់ [គំនូរបច្ចេកទេស]។ ចុចរូបតំណាងផ្ទុកឡើងនៅក្បាលប្រអប់។"
        },
        {
          "title": "ជ្រើស DXF តម្រឹម",
          "caption": "ក្នុងប្រអប់ [ផ្ទុកឡើងប្លង់] ផ្គូ DXF តម្រឹមជាមួយប្លង់នីមួយៗ ហើយចុច [ផ្ទុកឡើង]។"
        },
        {
          "title": "ចុច [ផ្ទុកឡើង]",
          "caption": "ពេលជ្រើស DXF តម្រឹម ឈ្មោះឯកសារបង្ហាញក្បែរប្លង់ ហើយ [ផ្ទុកឡើង] អាចចុចបាន។"
        },
        {
          "title": "ពិនិត្យការផ្ទុកឡើងរួចរាល់",
          "caption": "ការជូនដំណឹងថាផ្ទុកឡើងរួចរាល់ បង្ហាញនៅខាងស្ដាំលើ ហើយប្លង់លេចឡើងក្នុងប្រអប់ [គំនូរបច្ចេកទេស]។"
        }
      ]
    },
    "t-ref": {
      "title": "ទិន្នន័យយោង",
      "steps": [
        {
          "title": "បើកផ្ទាំង [ទិន្នន័យយោង]",
          "caption": "ជ្រើសគម្រោង ហើយចុចផ្ទាំង [ទិន្នន័យយោង]។"
        },
        {
          "title": "ចុចរូបតំណាងផ្ទុកឡើងឯកសារ",
          "caption": "មានប្រអប់ រូបភាព·ឯកសារ·វីដេអូ។ ចុចរូបតំណាងផ្ទុកឡើងនៅក្បាលប្រអប់ [ឯកសារ]។"
        },
        {
          "title": "ពិនិត្យការផ្ទុកឡើងរួចរាល់",
          "caption": "ការជូនដំណឹងថាផ្ទុកឡើងរួចរាល់ បង្ហាញនៅខាងស្ដាំលើ ហើយឯកសារលេចឡើងក្នុងប្រអប់ [ឯកសារ]។"
        }
      ]
    },
    "t-2dlayer": {
      "title": "បើក និងបិទស្រទាប់",
      "note": "ស្រទាប់ GIS·ស្រទាប់បន្ទាត់ ផ្ទុកឡើងនៅ <a href=\"#t-layerdata\">ទិន្នន័យស្រទាប់</a>។",
      "steps": [
        {
          "title": "បើក [LAYER]",
          "caption": "ចុច [LAYER] នៅរបារខាងឆ្វេងនៃអេក្រង់ត្រួតពិនិត្យ 2D។"
        },
        {
          "title": "បិទ [ចំណារ]",
          "caption": "ផ្ទាំង [LAYER] បើកឡើង។ កុងតាក់ [ចំណារ] ខាងលើបំផុត បើក និងបិទការបង្ហាញបញ្ហាលើផែនទី។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់ GIS]",
          "caption": "ការបង្ហាញបញ្ហាត្រូវបានបិទ។ ពង្រីក [ស្រទាប់ GIS]។"
        },
        {
          "title": "បើកផែនទីសុរិយោដី",
          "caption": "ស្រទាប់ GIS ដែលបានផ្ទុកឡើងបង្ហាញឡើង។ បើកកុងតាក់ផែនទីសុរិយោដី។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់លីនេអ៊ែរ]",
          "caption": "ព្រំដែនដីត្រួតលើផែនទី។ ពង្រីក [ស្រទាប់លីនេអ៊ែរ]។"
        },
        {
          "title": "បើកខ្សែផ្លូវគម្រោង",
          "caption": "បើកកុងតាក់ខ្សែផ្លូវគម្រោង។"
        },
        {
          "title": "មើលខ្សែផ្លូវដែលបានគូរ",
          "caption": "ខ្សែផ្លូវគម្រោងត្រូវបានគូរលើផែនទី។"
        },
        {
          "title": "បើក [DSM]",
          "caption": "បើក [DSM] ក្នុង [ស្រទាប់ចម្បង]។"
        },
        {
          "title": "មើលពណ៌កម្ពស់",
          "caption": "ពណ៌កម្ពស់ DSM បង្ហាញជំនួសរូបភាព Orthomosaic។ រូបភាព Orthomosaic និង DSM បើកបានតែម្ដងមួយ។"
        }
      ]
    },
    "t-folder": {
      "title": "ដាក់ស្រទាប់ជាថត",
      "note": "ចុចដោយសង្កត់ ⌘ (Ctrl នៅលើ Windows) ដើម្បីបន្ថែមស្រទាប់ដែលមិននៅជាប់គ្នាម្ដងមួយៗ។ ស្រទាប់លីនេអ៊ែរ និងបញ្ជីម៉ូដែល·ស្រទាប់ក្នុងអេក្រង់ 3D ក៏ដាក់ជាថតតាមវិធីដូចគ្នា ហើយមានតែ <a href=\"#t-member\">ម្ចាស់·អ្នកកែ</a> ទេដែលអាចបង្កើតថត និងផ្លាស់ទីធាតុបាន។",
      "steps": [
        {
          "title": "បើក [LAYER]",
          "caption": "ការដាក់ស្រទាប់ GIS ច្រើនក្នុងថតតែមួយ ធ្វើឲ្យបញ្ជីខ្លី ហើយអាចបើក·បិទទាំងថតបាន។ ចុច [LAYER] នៅរបារខាងឆ្វេងនៃអេក្រង់ត្រួតពិនិត្យ 2D។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់ GIS]",
          "caption": "ផ្ទាំង [LAYER] បើកឡើង។ ពង្រីក [ស្រទាប់ GIS]។"
        },
        {
          "title": "ចុចប៊ូតុងថតថ្មី",
          "caption": "ស្រទាប់ GIS ដែលបានផ្ទុកឡើងបង្ហាញឡើង។ ចុចប៊ូតុងថតថ្មី នៅក្បែរប្រអប់ស្វែងរក។"
        },
        {
          "title": "បញ្ចូលឈ្មោះថត",
          "caption": "ប្រអប់ឈ្មោះថតបង្ហាញនៅខាងលើបញ្ជី។ វាយឈ្មោះ ហើយចុច Enter។"
        },
        {
          "title": "សង្កត់ Shift ហើយចុចស្រទាប់ទីមួយ",
          "caption": "ថត [지하 시설물] (បរិក្ខារក្រោមដី) ត្រូវបានបង្កើត។ ឥឡូវជ្រើសស្រទាប់ដែលត្រូវដាក់ចូល។ សង្កត់ Shift ហើយចុចស្រទាប់បំពង់ទឹកស្អាត។"
        },
        {
          "title": "សង្កត់ Shift ហើយចុចស្រទាប់ចុងក្រោយ",
          "caption": "បំពង់ទឹកស្អាតត្រូវបានជ្រើស ហើយចំនួនដែលបានជ្រើសបង្ហាញនៅខាងលើបញ្ជី។ សង្កត់ Shift ហើយចុចស្រទាប់បំពង់ឧស្ម័ន។"
        },
        {
          "title": "អូសចូលថត",
          "caption": "ស្រទាប់ទាំងអស់ពីបំពង់ទឹកស្អាតដល់បំពង់ឧស្ម័នត្រូវបានជ្រើស។ ចាប់មួយក្នុងចំណោមនោះ ហើយអូសទៅលើថត [지하 시설물]។"
        },
        {
          "title": "ពង្រីកថត",
          "caption": "ស្រទាប់ដែលបានជ្រើសចូលក្នុងថតជាមួយគ្នា ហើយបញ្ជីខ្លីជាងមុន។ ចុចព្រួញនៅមុខថត ដើម្បីពង្រីក។"
        },
        {
          "title": "បើកកុងតាក់ថត",
          "caption": "ស្រទាប់បំពង់នៅក្នុងថត។ បើកកុងតាក់នៅជួរថត។"
        },
        {
          "title": "ពិនិត្យលើផែនទី",
          "caption": "ស្រទាប់ទាំងអស់ក្នុងថតបើកក្នុងពេលតែមួយ ហើយបំពង់ត្រូវបានគូរតាមបណ្ដោយផ្លូវលើផែនទី។"
        }
      ]
    },
    "t-compare": {
      "title": "ប្រៀបធៀបស៊េរីពេលវេលា",
      "steps": [
        {
          "title": "ចុច [ទិដ្ឋភាព 2 ផ្ទាំង]",
          "caption": "នៅក្រុមប៊ូតុងបំបែកអេក្រង់ ខាងឆ្វេងលើនៃផែនទី ចុច [ទិដ្ឋភាព 2 ផ្ទាំង]។"
        },
        {
          "title": "បើកកាលបរិច្ឆេទផ្ទាំងស្ដាំ",
          "caption": "អេក្រង់ចែកជាពីរ។ ចុចកាលបរិច្ឆេទនៅខាងលើផ្ទាំងស្ដាំ។"
        },
        {
          "title": "ជ្រើសកាលបរិច្ឆេទដើម្បីប្រៀបធៀប",
          "caption": "បង្ហាញតែថ្ងៃថតដែលដំណើរការ 2D រួច។ ជ្រើសកាលបរិច្ឆេទដែលចង់ប្រៀបធៀប។"
        },
        {
          "title": "ចុច [ទិដ្ឋភាព 4 ផ្ទាំង]",
          "caption": "កន្លែងដដែលពេលកំពុងជីក និងក្រោយជួសជុល បង្ហាញទន្ទឹមគ្នា។ លើកនេះ ចុច [ទិដ្ឋភាព 4 ផ្ទាំង]។"
        },
        {
          "title": "បើកកាលបរិច្ឆេទផ្ទាំងស្ដាំក្រោម",
          "caption": "អេក្រង់ចែកជាបួន។ ចុចកាលបរិច្ឆេទនៃផ្ទាំងស្ដាំក្រោម។"
        },
        {
          "title": "ជ្រើសកាលបរិច្ឆេទ",
          "caption": "ជ្រើសថ្ងៃថតដែលចង់មើលក្នុងផ្ទាំងនេះ។"
        },
        {
          "title": "អូសផ្ទាំងមួយ",
          "caption": "ផ្ទាំងនីមួយៗបង្ហាញថ្ងៃថតដែលអ្នកជ្រើសសម្រាប់វា។ សាកអូសផ្ទាំងមួយ។"
        },
        {
          "title": "មើលផ្ទាំងផ្លាស់ទីជាមួយគ្នា",
          "caption": "ផ្ទាំងទាំងអស់ផ្លាស់ទីជាមួយគ្នា។"
        }
      ]
    },
    "t-issue": {
      "title": "បង្កើត និងកែបញ្ហា",
      "note": "បើដឹងកូអរដោនេ ក៏អាចបង្កើតបញ្ហាដោយបញ្ចូលទីតាំង (x-y ឬរយៈបណ្ដោយ/រយៈទទឹង) នៅ <ui>ISSUE</ui> → <ui>បង្កើតបញ្ហា</ui> បានដែរ។",
      "steps": [
        {
          "title": "ជ្រើសឧបករណ៍ [ចំណុច]",
          "caption": "ក្នុងឧបករណ៍គូរ [បង្កើត] ជ្រើស [ចំណុច]។"
        },
        {
          "title": "ដាក់ចំណុចលើផែនទី",
          "caption": "ចុចលើផែនទីតាមស្លាកណែនាំក្បែរទស្សន៍ទ្រនិច។"
        },
        {
          "title": "ចុច [កែកំពូល]",
          "caption": "វារក្សាទុកជាបញ្ហាភ្លាមៗ ជាមួយការជូនដំណឹង [ការបង្កើតចំណារបានបញ្ចប់]។ ចុច [កែកំពូល] ក្នុង [កែប្រែ]។"
        },
        {
          "title": "អូសចំណុច",
          "caption": "អូសចំណុច ដើម្បីផ្លាស់ទី។"
        },
        {
          "title": "ពិនិត្យទីតាំងថ្មី",
          "caption": "វារក្សាទុកភ្លាមៗនៅទីតាំងដែលបានដាក់។"
        }
      ]
    },
    "t-issueinfo": {
      "title": "ស្វែងរកបញ្ហា និងមតិយោបល់",
      "steps": [
        {
          "title": "បើក [ISSUE]",
          "caption": "ចុច [ISSUE] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "បើក [ច្រោះ]",
          "caption": "បញ្ហាត្រូវបានដាក់ជាក្រុមតាមប្រភេទ។ ចុច [ច្រោះ]។"
        },
        {
          "title": "ដកលក្ខខណ្ឌ",
          "caption": "ដំបូង លក្ខខណ្ឌទាំងអស់ត្រូវបានជ្រើស ហើយលក្ខខណ្ឌដែលចុចនឹងត្រូវដកចេញ។ ចុច [សញ្ញា] ដើម្បីដកចេញ។"
        },
        {
          "title": "ចុច [ពិនិត្យ]",
          "caption": "[សញ្ញា] ត្រូវបានដកចេញ។ ចុច [ពិនិត្យ]។"
        },
        {
          "title": "ពង្រីកក្បាលប្រភេទ",
          "caption": "នៅសល់តែបញ្ហាដែលត្រូវនឹងលក្ខខណ្ឌ។ ចុចក្បាលប្រភេទ ដើម្បីពង្រីកបញ្ហាទាំងនោះ។"
        },
        {
          "title": "ចុច [ផ្លាស់ទីទៅបញ្ហា]",
          "caption": "ចុចរូបតំណាងទីតាំង ([ផ្លាស់ទីទៅបញ្ហា]) នៅជួរនោះ។"
        },
        {
          "title": "រមូរផ្ទាំងចុះ",
          "caption": "ផែនទីផ្លាស់ទៅបញ្ហានោះ ហើយ [ព័ត៌មានបញ្ហា] បើកឡើងជាមួយនិន្នាការកម្រិតតាមថ្ងៃថត។ រមូរផ្ទាំងចុះ។"
        },
        {
          "title": "បើកមតិយោបល់",
          "caption": "ចុច [មតិយោបល់ 2] នៅខាងក្រោម។"
        },
        {
          "title": "សរសេរមតិយោបល់",
          "caption": "នេះជាប្រអប់មតិយោបល់ ដែលមើលមតិយោបល់ភ្ជាប់រូបថតបានផងដែរ។ សរសេរមតិយោបល់ក្នុងប្រអប់បញ្ចូល។"
        },
        {
          "title": "ចុចប៊ូតុងផ្ញើ",
          "caption": "ចុចប៊ូតុងផ្ញើ។"
        },
        {
          "title": "ពិនិត្យមតិយោបល់ថ្មី",
          "caption": "មតិយោបល់ត្រូវបានបង្ហោះភ្លាមៗ។"
        }
      ]
    },
    "t-measure": {
      "title": "ការវាស់ស្ទង់បញ្ហា",
      "note": "ប្រើរូបតំណាងទាញយកក្បែរចំណងជើងផ្នែកនីមួយៗ ដើម្បីរក្សាទុកតម្លៃវាស់ស្ទង់ ទំហំ និងកូអរដោនេជាឯកសារ CSV។",
      "steps": [
        {
          "title": "ចុចបញ្ហាពហុកោណ",
          "caption": "ចុចបញ្ហាពហុកោណលើផែនទី។"
        },
        {
          "title": "ចុចផ្ទាំង [ការវាស់ស្ទង់]",
          "caption": "[ព័ត៌មានបញ្ហា] បើកឡើង។ ចុចផ្ទាំង [ការវាស់ស្ទង់]។"
        },
        {
          "title": "បើកប្រអប់កាលបរិច្ឆេទ",
          "caption": "បញ្ហាពហុកោណបង្ហាញផ្ទៃផ្ដេក ផ្ទៃ 3D និងផ្ទៃដី។ ចុចប្រអប់កាលបរិច្ឆេទនៅខាងលើ។"
        },
        {
          "title": "ជ្រើសកាលបរិច្ឆេទដើម្បីប្រៀបធៀប",
          "caption": "ថ្ងៃថតដែលមានបញ្ហានេះបង្ហាញឡើង។ ជ្រើសកាលបរិច្ឆេទដែលចង់ប្រៀបធៀប។"
        },
        {
          "title": "រមូរផ្ទាំងចុះ",
          "caption": "កាតវាស់ស្ទង់ត្រូវបានបន្ថែមសម្រាប់កាលបរិច្ឆេទនីមួយៗ ហើយកាតប្រៀបធៀបខាងក្រោមបង្ហាញភាពខុសគ្នា។ រមូរផ្ទាំងចុះ។"
        },
        {
          "title": "បញ្ចូលកម្ពស់ផ្ទៃបាត",
          "caption": "ដើម្បីគណនាទំហំ សូមបញ្ចូលកម្ពស់ផ្ទៃបាត។"
        },
        {
          "title": "ចុច [ការគណនាទំហំ]",
          "caption": "ចុច [ការគណនាទំហំ]។"
        },
        {
          "title": "មើលទំហំតាមកាលបរិច្ឆេទ",
          "caption": "សម្រាប់កាលបរិច្ឆេទនីមួយៗ ផ្នែកខាងលើផ្ទៃបាតជា CUT (ការកាត់) ហើយផ្នែកខាងក្រោមជា FILL (ការបំពេញ)។"
        },
        {
          "title": "ចុចបញ្ហាបន្ទាត់",
          "caption": "លើកនេះ ចុចបញ្ហាបន្ទាត់លើផែនទី។"
        },
        {
          "title": "ចុចផ្ទាំង [ការវាស់ស្ទង់]",
          "caption": "ចុចផ្ទាំង [ការវាស់ស្ទង់]។"
        },
        {
          "title": "រមូរផ្ទាំងចុះ",
          "caption": "បញ្ហាបន្ទាត់បង្ហាញចម្ងាយផ្ដេក ចម្ងាយ 3D និងចម្ងាយផ្ទៃដី។ រមូរផ្ទាំងចុះ។"
        },
        {
          "title": "ពង្រីក [ខ្សែ]",
          "caption": "ពង្រីក [ខ្សែ] នៅខាងក្រោមបំផុត។"
        },
        {
          "title": "មើលតម្លៃតាមខ្សែនីមួយៗ",
          "caption": "ខ្សែនីមួយៗបង្ហាញចម្ងាយ ភាពខុសគ្នានៃកម្ពស់ និងជម្រាល។"
        }
      ]
    },
    "t-issueexport": {
      "title": "នាំចេញបញ្ហា",
      "note": "បើដកកាលបរិច្ឆេទចេញពី <ui>ស៊េរីពេលវេលាដែលបានជ្រើសរើស</ui> ខាងស្ដាំ ហើយចុច <ui>បញ្ជាក់</ui> បញ្ហានៅថ្ងៃថតនោះនឹងត្រូវលុប។",
      "steps": [
        {
          "title": "ចុចបញ្ហា",
          "caption": "ចុចបញ្ហាដែលចង់តាមដាននៅថ្ងៃថតផ្សេងទៀត។"
        },
        {
          "title": "រមូរផ្ទាំងចុះ",
          "caption": "[ព័ត៌មានបញ្ហា] បើកឡើង ហើយនិន្នាការកម្រិតមានថ្ងៃថតតែមួយ។ រមូរផ្ទាំងចុះ។"
        },
        {
          "title": "ចុច [នាំចេញបញ្ហា]",
          "caption": "ចុច [នាំចេញបញ្ហា] នៅខាងក្រោម។"
        },
        {
          "title": "ជ្រើសថ្ងៃថត",
          "caption": "នេះជាប្រអប់ [ជ្រើសរើសស៊េរីពេលវេលាដើម្បីវិភាគ]។ ក្នុង [បញ្ជីស៊េរីពេលវេលា] ខាងឆ្វេង ជ្រើសថ្ងៃថតដែលចង់នាំចេញទៅ។"
        },
        {
          "title": "ផ្លាស់ទីដោយ [>]",
          "caption": "ប្រើ [>] នៅកណ្ដាល ដើម្បីផ្លាស់ទៅ [ស៊េរីពេលវេលាដែលបានជ្រើសរើស] ខាងស្ដាំ។ [»] ផ្លាស់ទីកាលបរិច្ឆេទទាំងអស់មុន ឬក្រោយថ្ងៃយោងក្នុងពេលតែមួយ។"
        },
        {
          "title": "ចុច [បញ្ជាក់]",
          "caption": "ចុច [បញ្ជាក់]។"
        },
        {
          "title": "ពិនិត្យការជូនដំណឹង",
          "caption": "ការជូនដំណឹង [ការភ្ជាប់បញ្ហាបានជោគជ័យ] បង្ហាញឡើង។"
        },
        {
          "title": "មើលនិន្នាការកម្រិតដែលបានបន្ថែម",
          "caption": "ថ្ងៃថតដែលបានជ្រើសត្រូវបានបន្ថែមទៅ [និន្នាការកម្រិតបញ្ហា] ដូច្នេះអាចតាមដានបញ្ហាដដែលតាមកាលបរិច្ឆេទ។"
        }
      ]
    },
    "t-droneimg": {
      "title": "មើលរូបថតដើមពីដ្រូន",
      "steps": [
        {
          "title": "ជ្រើសឧបករណ៍ [រូបភាពដ្រូន]",
          "caption": "ចុច [រូបភាពដ្រូន] (រូបតំណាងកាមេរ៉ា) ក្នុង [ផ្សេងៗ] នៃឧបករណ៍គូរ។"
        },
        {
          "title": "ចុចលើផែនទី",
          "caption": "ចុចកន្លែងដែលចង់មើលរូបថតលើផែនទី។"
        },
        {
          "title": "ជ្រើសរូបភាពតូចផ្សេង",
          "caption": "[បញ្ជីរូបភាព] ខាងក្រោមបង្ហាញរូបថតដើមដែលថតក្នុងរង្វង់ 100m ពីកន្លែងនោះ។ ចុចរូបភាពតូចផ្សេង។"
        },
        {
          "title": "ចុចពេញអេក្រង់",
          "caption": "កាតប្ដូរទៅរូបថតនោះ ហើយទីតាំងថតបង្ហាញលើផែនទី។ ចុចប៊ូតុងពេញអេក្រង់លើកាត។"
        },
        {
          "title": "ទៅរូបថតបន្ទាប់",
          "caption": "រូបថតបើកពេញអេក្រង់។ ប្រើព្រួញខាងក្រោម ដើម្បីទៅរូបថតបន្ទាប់។"
        },
        {
          "title": "មើលរូបថតបន្ទាប់",
          "caption": "រូបថតបន្ទាប់បង្ហាញឡើង។"
        }
      ]
    },
    "t-geolog": {
      "title": "រូបថត·វីដេអូ (GeoLog)",
      "steps": [
        {
          "title": "បើក [GEOLOG]",
          "caption": "ចុច [GEOLOG] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "ចុច [+]",
          "caption": "នេះជាបញ្ជីរូបថត·វីដេអូការដ្ឋាន។ ចុច [+] នៅខាងលើ។"
        },
        {
          "title": "ជ្រើស [បញ្ចូលឯកសារ]",
          "caption": "ពី [បញ្ចូលឯកសារ] [បញ្ចូលថត] [បញ្ចូលលើផែនទី] ជ្រើស [បញ្ចូលឯកសារ]។"
        },
        {
          "title": "ចុច [កំណត់ទីតាំង] ខាងលើ",
          "caption": "រូបថតដែលបានជ្រើសត្រូវបានផ្ទុកឡើងភ្លាមៗ។ រូបថតគ្មានទីតាំងមានសម្គាល់ [គ្មានទីតាំង] ហើយគ្មានម្ជុលលើផែនទី។ ចុច [កំណត់ទីតាំង] នៅរបារឧបករណ៍ខាងលើ។"
        },
        {
          "title": "ជ្រើស [កំណត់ទីតាំង] ក្នុងប្រអប់",
          "caption": "ក្នុងប្រអប់ដែលបើកឡើង ជ្រើស [កំណត់ទីតាំង]។"
        },
        {
          "title": "ជ្រើសរូបថត",
          "caption": "ជ្រើសរូបថតដែលត្រូវកំណត់ទីតាំង។"
        },
        {
          "title": "ចុច [ដាក់លើផែនទី]",
          "caption": "ចុច [ដាក់លើផែនទី]។"
        },
        {
          "title": "ចុចកន្លែងដែលបានថត",
          "caption": "ចុចកន្លែងដែលបានថតរូបលើផែនទី។"
        },
        {
          "title": "ចុច [មើលលម្អិត]",
          "caption": "ម្ជុលរូបថត និងកាតមើលជាមុនលេចឡើងនៅទីនោះ។ ចុច [មើលលម្អិត] លើកាត។"
        },
        {
          "title": "មើលក្នុងផ្ទាំងធំ",
          "caption": "មើលរូបថតធំក្នុងផ្ទាំងធំ ហើយពិនិត្យអ្នកបញ្ចូល ថ្ងៃថត និងប្រធានបទ។"
        }
      ]
    },
    "t-report": {
      "title": "របាយការណ៍",
      "note": "របាយការណ៍រួមបញ្ចូលបញ្ហាទាំងអស់នៃថ្ងៃថតបច្ចុប្បន្ន ទោះបីបានច្រោះក្នុង <ui>ISSUE</ui> ក៏ដោយ។",
      "steps": [
        {
          "title": "បើក [REPORT]",
          "caption": "ចុច [REPORT] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "បញ្ចូលចំណងជើង",
          "caption": "ព័ត៌មានអ្នកនិពន្ធត្រូវបានបំពេញដោយព័ត៌មានរបស់អ្នក។ បញ្ចូលចំណងជើងរបាយការណ៍។"
        },
        {
          "title": "ចុច [នាំចេញរបាយការណ៍]",
          "caption": "ចុច [នាំចេញរបាយការណ៍]។"
        },
        {
          "title": "ចុចប៊ូតុងទាញយក PDF",
          "caption": "ការមើលជាមុន A4 បើកឡើង។ ចុចប៊ូតុងទាញយក PDF នៅខាងលើ ដើម្បីរក្សាទុកជាឯកសារ PDF។"
        }
      ]
    },
    "t-capture": {
      "title": "ពិនិត្យកូអរដោនេ និងចាប់យកតំបន់",
      "steps": [
        {
          "title": "ចុចលើផែនទី",
          "caption": "ចុចកន្លែងដែលចង់មើលកូអរដោនេលើផែនទី។"
        },
        {
          "title": "បើកម៉ឺនុយប្រព័ន្ធកូអរដោនេ",
          "caption": "របារកូអរដោនេខាងស្ដាំក្រោមបង្ហាញ x·y·z នៃកន្លែងនោះ។ ចុចប្រអប់ប្រព័ន្ធកូអរដោនេនៅខាងឆ្វេងរបារ។"
        },
        {
          "title": "ជ្រើស [Google Mercator]",
          "caption": "ជ្រើសប្រព័ន្ធកូអរដោនេដែលចង់បង្ហាញ។ ចុច [Google Mercator]។"
        },
        {
          "title": "ពិនិត្យកូអរដោនេថ្មី",
          "caption": "កូអរដោនេប្ដូរទៅប្រព័ន្ធដែលបានជ្រើស។"
        },
        {
          "title": "ជ្រើស [ចាប់យកតំបន់]",
          "caption": "លើកនេះ ចុច [ចាប់យកតំបន់] ក្នុង [ផ្សេងៗ] នៃឧបករណ៍គូរ។"
        },
        {
          "title": "មើលការណែនាំកំណត់តំបន់",
          "caption": "ការណែនាំឲ្យអូសកំណត់តំបន់ដែលត្រូវចាប់យកលើផែនទី បង្ហាញឡើង។"
        },
        {
          "title": "អូសកំណត់តំបន់",
          "caption": "អូសតំបន់ដែលត្រូវចាប់យកលើផែនទី។"
        },
        {
          "title": "ជ្រើសកម្រិតពង្រីកលទ្ធផល",
          "caption": "ទំហំលើដី ទំហំលទ្ធផល និង GSD ពិតប្រាកដ បង្ហាញឡើង។ ជ្រើសកម្រិតពង្រីកលទ្ធផល។"
        },
        {
          "title": "ចុចប៊ូតុងទាញយក PNG",
          "caption": "ទំហំលទ្ធផលធំឡើងបួនដង។ ចុចប៊ូតុងទាញយក PNG ដើម្បីរក្សាទុកជាឯកសារ PNG។"
        }
      ]
    },
    "t-pf-dxf": {
      "title": "ពិនិត្យផ្នែក DXF (2D)",
      "note": "ស្រទាប់លីនេអ៊ែរ (DXF) ត្រូវផ្ទុកឡើងទៅប្រអប់ស្រទាប់បន្ទាត់ ក្នុង <a href=\"#t-layerdata\">ទិន្នន័យស្រទាប់</a>។",
      "steps": [
        {
          "title": "ចុច [LAYER]",
          "caption": "នៅរបារខាងឆ្វេងនៃអេក្រង់ត្រួតពិនិត្យ 2D ចុច [LAYER]។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់លីនេអ៊ែរ]",
          "caption": "នេះជាផ្ទាំងស្រទាប់។ ពង្រីក [ស្រទាប់លីនេអ៊ែរ]។"
        },
        {
          "title": "ចុច [បើកក្រាហ្វផ្នែក]",
          "caption": "ស្រទាប់លីនេអ៊ែរ (DXF) ដែលបានផ្ទុកឡើង បង្ហាញឡើង។ ចុចរូបតំណាងក្រាហ្វ ([បើកក្រាហ្វផ្នែក]) នៅខាងស្ដាំជួរ។"
        },
        {
          "title": "ចុច [ពិនិត្យ] នៃផ្នែកបណ្ដោយ",
          "caption": "ផ្ទាំងកំណត់ផ្នែកកាត់បើកឡើង ហើយផ្លូវ និងចំណុចស្ទង់ (0+000, 0+020 …) ត្រូវបានគូសលើផែនទី។ ចុច [ពិនិត្យ] នៃ [ផ្នែកបណ្ដោយ]។"
        },
        {
          "title": "ចុចលើខ្សែក្រាហ្វ",
          "caption": "ក្រាហ្វផ្នែកបណ្ដោយបើកនៅខាងក្រោម។ អ័ក្សផ្ដេកជាចម្ងាយពីចំណុចចាប់ផ្ដើម ហើយអ័ក្សបញ្ឈរជាកម្ពស់។ ចុចលើខ្សែក្រាហ្វ។"
        },
        {
          "title": "មើលទីតាំងលើផែនទី",
          "caption": "ចំណុចដែលបានចុច ត្រូវបានសម្គាល់ជាចំណុចលើផ្លូវនៅលើផែនទី ហើយជួរខាងក្រោមក្រាហ្វ បង្ហាញកូអរដោនេ និងកម្ពស់នៃចំណុចនោះ។"
        },
        {
          "title": "បញ្ចូល 80 ក្នុងចំណុចបញ្ចប់",
          "caption": "បន្ទាប់មក មើលផ្នែកឆ្លង។ បញ្ចូល 80 ក្នុងចំណុចបញ្ចប់នៃ [ផ្នែកឆ្លង] ក្នុងផ្ទាំងកំណត់។"
        },
        {
          "title": "ចុច [ពិនិត្យ]",
          "caption": "ទុកទទឹង (ឆ្វេង·ស្ដាំ 10 m) និងគម្លាត (20 m) ដដែល ហើយចុច [ពិនិត្យ]។"
        },
        {
          "title": "ចុចប៊ូតុងផ្នែកបន្ទាប់",
          "caption": "ក្រាហ្វផ្នែកឆ្លងនៃចំណុចស្ទង់ទីមួយបើកឡើង ហើយខ្សែផ្នែកឆ្លងត្រូវបានគូសលើផែនទី នៅចំណុចស្ទង់នីមួយៗ (ចំណុចស្ទង់បច្ចុប្បន្នពណ៌ក្រហម)។ ចុចប៊ូតុងផ្នែកបន្ទាប់ (›) នៅក្បាលក្រាហ្វ។"
        },
        {
          "title": "ចុចខ្សែផ្នែកឆ្លងលើផែនទី",
          "caption": "ប្ដូរទៅចំណុចស្ទង់បន្ទាប់ (020)។ ចុចខ្សែផ្នែកឆ្លង 0+060 លើផែនទី ក៏ប្ដូរទៅចំណុចស្ទង់នោះដែរ។"
        },
        {
          "title": "ចុច [រក្សាទុក]",
          "caption": "ក្រាហ្វប្ដូរទៅចំណុចស្ទង់នោះ (060)។ ដើម្បីរក្សាទុកចន្លោះនេះ ចុច [រក្សាទុក]។"
        },
        {
          "title": "មើលការជូនដំណឹងរក្សាទុក",
          "caption": "「ផ្នែកឆ្លងត្រូវបានរក្សាទុក។」 បង្ហាញឡើង។"
        },
        {
          "title": "ចុចកាតចន្លោះដែលបានរក្សាទុក",
          "caption": "បញ្ជី [បញ្ជីផ្នែកឆ្លង] ពង្រីកឡើង។ ចុចកាតនៃចន្លោះដែលបានរក្សាទុក (0 ~ 080)។"
        },
        {
          "title": "បញ្ចូលចំណុចស្ទង់ 50",
          "caption": "ព័ត៌មានចន្លោះ និងបញ្ជីចំណុចស្ទង់ បង្ហាញឡើង។ បញ្ចូល 50 ក្នុងប្រអប់ខាងក្រោម។"
        },
        {
          "title": "ចុច [បន្ថែមផ្នែកឆ្លងពិសេស]",
          "caption": "ចុច [បន្ថែមផ្នែកឆ្លងពិសេស] (+) នៅខាងស្ដាំ។"
        },
        {
          "title": "មើលការជូនដំណឹងបន្ថែម",
          "caption": "「ផ្នែកឆ្លងពិសេសត្រូវបានបន្ថែម។」 បង្ហាញឡើង។"
        },
        {
          "title": "ចុចចំណុចស្ទង់ 050",
          "caption": "ចំណុចស្ទង់ 050 ត្រូវបានបន្ថែមក្នុងបញ្ជី។ ចុច 050។"
        },
        {
          "title": "មើលចាប់ពីចំណុចស្ទង់ 050",
          "caption": "ក្រាហ្វនៃចន្លោះដែលបានរក្សាទុក បើកចាប់ពីចំណុចស្ទង់ 050។"
        }
      ]
    },
    "t-pf-dxf3d": {
      "title": "ពិនិត្យផ្នែក DXF (3D)",
      "steps": [
        {
          "title": "ចុច [LAYER]",
          "caption": "នៅរបារខាងឆ្វេងនៃអេក្រង់ 3D ចុច [LAYER]។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់លីនេអ៊ែរ]",
          "caption": "នេះជាផ្ទាំងស្រទាប់ 3D។ ពង្រីក [ស្រទាប់លីនេអ៊ែរ]។"
        },
        {
          "title": "ចុច [បើកក្រាហ្វផ្នែក]",
          "caption": "ចុចរូបតំណាងក្រាហ្វ ([បើកក្រាហ្វផ្នែក]) នៅខាងស្ដាំជួរ។"
        },
        {
          "title": "ចុច [ពិនិត្យ] នៃផ្នែកបណ្ដោយ",
          "caption": "ផ្ទាំងកំណត់ផ្នែកកាត់ដូចក្នុង 2D បើកឡើង។ ចុច [ពិនិត្យ] នៃ [ផ្នែកបណ្ដោយ]។"
        },
        {
          "title": "ចុច [ពិនិត្យ] នៃផ្នែកឆ្លង",
          "caption": "ចំណុចស្ទង់បង្ហាញលើម៉ូដែល ហើយក្រាហ្វផ្នែកបណ្ដោយបើកនៅខាងក្រោម។ ចុច [ពិនិត្យ] នៃ [ផ្នែកឆ្លង]។"
        },
        {
          "title": "ចុចខ្សែផ្នែកឆ្លងលើម៉ូដែល",
          "caption": "ខ្សែផ្នែកឆ្លងត្រូវបានគូសលើម៉ូដែល នៅចំណុចស្ទង់នីមួយៗ ហើយក្រាហ្វផ្នែកឆ្លងនៃចំណុចស្ទង់ទីមួយបើកឡើង។ ចុចខ្សែផ្នែកឆ្លង 0+040 លើម៉ូដែល។"
        },
        {
          "title": "មើលផ្នែកឆ្លងនៃចំណុចស្ទង់នោះ",
          "caption": "ក្រាហ្វខាងក្រោម ប្ដូរទៅផ្នែកឆ្លងនៃចំណុចស្ទង់នោះ (040)។"
        }
      ]
    },
    "t-pf-export": {
      "title": "នាំចេញផ្នែក DXF",
      "note": "អាចនាំចេញបានតែពីចន្លោះដែលបានរក្សាទុកប៉ុណ្ណោះ។ ជាដំបូង រក្សាទុកចន្លោះក្នុង <a href=\"#t-pf-dxf\">ពិនិត្យផ្នែក DXF (2D)</a>។",
      "steps": [
        {
          "title": "ចុច [បញ្ជីផ្នែកឆ្លង]",
          "caption": "នាំចេញផ្នែកឆ្លងនៃចន្លោះដែលបានរក្សាទុក ជាឯកសារ។ ក្នុង [ផ្នែកឆ្លង] ចុច [បញ្ជីផ្នែកឆ្លង]។"
        },
        {
          "title": "ចុច [នាំចេញ]",
          "caption": "ចុចរូបតំណាងនាំចេញ ([នាំចេញ]) នៅខាងស្ដាំកាតចន្លោះដែលបានរក្សាទុក។"
        },
        {
          "title": "ចុច [ថ្ងៃថត]",
          "caption": "នេះជាបង្អួច [នាំចេញទិន្នន័យផ្នែកឆ្លង]។ ចន្លោះ·ទទឹង·គម្លាត បង្ហាញនៅខាងលើ។ ចុច [ថ្ងៃថត] ដើម្បីជ្រើសថ្ងៃដែលត្រូវដាក់បញ្ចូល។"
        },
        {
          "title": "ជ្រើសថ្ងៃថត",
          "caption": "នេះជាបញ្ជីថ្ងៃថត។ អាចជ្រើសច្រើនថ្ងៃព្រមគ្នាបាន។ ជ្រើស 2024/01/19។"
        },
        {
          "title": "ចុច [បង្កើត]",
          "caption": "ថ្ងៃថតដែលបានជ្រើស ត្រូវបានបញ្ចូល។ មានគំនូរបច្ចេកទេសតែមួយ ដូច្នេះ [កម្ពស់ដី] និង [កម្ពស់គម្រោង] ត្រូវបានជ្រើសរួចហើយ។ ចុច [បង្កើត]។"
        },
        {
          "title": "មើលការជូនដំណឹងបង្កើត",
          "caption": "「ការបង្កើតឯកសារបានចាប់ផ្ដើម។」 បង្ហាញនៅជ្រុងខាងស្ដាំខាងលើ។"
        },
        {
          "title": "បិទបង្អួច",
          "caption": "ឯកសារ [កំពុងបង្កើត] បង្ហាញក្នុងបញ្ជីខាងក្រោម។ បញ្ជីធ្វើបច្ចុប្បន្នភាព ពេលបើកបង្អួចម្ដងទៀត។ បិទបង្អួច។"
        },
        {
          "title": "ចុច [នាំចេញ] ម្ដងទៀត",
          "caption": "ពេលការបង្កើតជិតរួច ចុច [នាំចេញ] ម្ដងទៀត។"
        },
        {
          "title": "ជ្រើសឯកសារដែលរួចរាល់",
          "caption": "បញ្ជីត្រូវបានធ្វើបច្ចុប្បន្នភាព ហើយស្ថានភាពប្ដូរជា [បញ្ចប់]។ ចុចប្រអប់ធីកមុខឯកសារ ដើម្បីជ្រើស។"
        },
        {
          "title": "ចុច [ទាញយក]",
          "caption": "ឯកសារត្រូវបានជ្រើស។ ចុច [ទាញយក]។"
        },
        {
          "title": "ជ្រើសទម្រង់ CSV",
          "caption": "ជ្រើសទម្រង់ដែលត្រូវទាញយក (CSV·DXF·តារាងដីសំណង់·បរិមាណផ្នែកដីសំណង់)។ ចុច CSV។"
        },
        {
          "title": "មើលការជូនដំណឹងទាញយក",
          "caption": "「ឯកសារ CSV ត្រូវបានទាញយក។」 បង្ហាញនៅជ្រុងខាងស្ដាំខាងលើ។"
        }
      ]
    },
    "t-pf-issue": {
      "title": "ពិនិត្យផ្នែកបញ្ហាបន្ទាត់ (2D)",
      "steps": [
        {
          "title": "ចុចបញ្ហាប្រភេទបន្ទាត់",
          "caption": "ចុចបញ្ហាប្រភេទបន្ទាត់ លើផែនទី 2D។"
        },
        {
          "title": "ចុចផ្ទាំង [ការវាស់ស្ទង់]",
          "caption": "[ព័ត៌មានបញ្ហា] បើកឡើង។ ចុចផ្ទាំង [ការវាស់ស្ទង់]។"
        },
        {
          "title": "ចុច [ពិនិត្យផ្នែក]",
          "caption": "នៅក្រោមប្រវែងបន្ទាត់ មានការកំណត់ផ្នែកកាត់ និងផ្នែកឆ្លង។ ទុកចន្លោះផ្នែកបន្ទាត់ (P1~P3) ដដែល ហើយចុច [ពិនិត្យផ្នែក]។"
        },
        {
          "title": "រំកិលផ្ទាំងចុះក្រោម",
          "caption": "ក្រាហ្វផ្នែកបណ្ដោយដែលកាត់តាមបន្ទាត់បញ្ហា បើកនៅខាងក្រោម។ លើកនេះ មើលផ្នែកឆ្លង។ រំកិលផ្ទាំង [ព័ត៌មានបញ្ហា] ចុះក្រោម។"
        },
        {
          "title": "ចុច [ពិនិត្យផ្នែកឆ្លង]",
          "caption": "ក្នុងការកំណត់ផ្នែកឆ្លង កំណត់ចន្លោះផ្នែកបន្ទាត់·ចំណុចស្ទង់ចាប់ផ្ដើម·គម្លាត·ទទឹង ហើយចុច [ពិនិត្យផ្នែកឆ្លង]។"
        },
        {
          "title": "មើលផ្នែកឆ្លងតាមខ្សែបញ្ហា",
          "caption": "ផ្នែកឆ្លងបើកតាមគម្លាតនីមួយៗ តាមខ្សែបញ្ហា ហើយខ្សែផ្នែកឆ្លងត្រូវបានគូសលើផែនទី នៅចំណុចស្ទង់នីមួយៗ។"
        }
      ]
    },
    "t-pf-issue3d": {
      "title": "ពិនិត្យផ្នែកបញ្ហាបន្ទាត់ (3D)",
      "steps": [
        {
          "title": "ចុច [ISSUE]",
          "caption": "នៅអេក្រង់ 3D ក៏អាចមើលផ្នែកពីបញ្ហាប្រភេទបន្ទាត់បានដែរ។ ចុច [ISSUE] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "ពង្រីកក្រុមប្រភេទ",
          "caption": "បញ្ហាត្រូវបានដាក់ជាក្រុមតាមប្រភេទ។ ពង្រីកប្រភេទដែលមានបញ្ហាប្រភេទបន្ទាត់។"
        },
        {
          "title": "ចុច [ផ្លាស់ទីទៅបញ្ហា]",
          "caption": "ចុច [ផ្លាស់ទីទៅបញ្ហា] នៅជួរនៃបញ្ហាប្រភេទបន្ទាត់។"
        },
        {
          "title": "ផ្អៀងដោយប៊ូតុងស្ដាំ",
          "caption": "កាមេរ៉ាផ្លាស់ទៅលើបញ្ហា ហើយមើលចុះត្រង់ ហើយ [ព័ត៌មានបញ្ហា] បើកឡើង។ ចុចប៊ូតុងស្ដាំឱ្យជាប់ ហើយអូសឡើងលើ ដើម្បីផ្អៀងម៉ូដែល។"
        },
        {
          "title": "ចុចផ្ទាំង [ការវាស់ស្ទង់]",
          "caption": "ឥឡូវមើលម៉ូដែលពីចំហៀង។ ចុចផ្ទាំង [ការវាស់ស្ទង់]។"
        },
        {
          "title": "ចុច [ពិនិត្យផ្នែក]",
          "caption": "មានការកំណត់ផ្នែកកាត់ និងផ្នែកឆ្លង ដូចអេក្រង់ 2D។ ចុច [ពិនិត្យផ្នែក]។"
        },
        {
          "title": "មើលក្រាហ្វក្នុង 3D",
          "caption": "ក្រាហ្វផ្នែកបណ្ដោយដែលកាត់តាមបន្ទាត់បញ្ហា បើកនៅខាងក្រោម ហើយលេខកំពូល (1·2·3) ត្រូវបានសម្គាល់លើម៉ូដែល។"
        }
      ]
    },
    "t-pf-3d": {
      "title": "ឧបករណ៍វាស់ផ្នែក 3D",
      "steps": [
        {
          "title": "ចុច [វាស់ប្រវែងបណ្ដោយ]",
          "caption": "នៅអេក្រង់ត្រួតពិនិត្យ 3D អាចគូសបន្ទាត់ផ្ទាល់លើម៉ូដែល ដើម្បីមើលផ្នែកកាត់។ ក្នុងឧបករណ៍ [វាស់] នៅខាងឆ្វេង ចុច [វាស់ប្រវែងបណ្ដោយ]។"
        },
        {
          "title": "ដាក់ចំណុចទីមួយ",
          "caption": "ចុចលើម៉ូដែល ដើម្បីដាក់ចំណុចទីមួយនៃបន្ទាត់។ ដាក់ចំណុចតាមកន្លែងជីក។"
        },
        {
          "title": "ដាក់ចំណុចបន្ទាប់",
          "caption": "ដាក់ចំណុចបន្ទាប់។"
        },
        {
          "title": "ចុចពីរដងដើម្បីបញ្ចប់",
          "caption": "ដាក់ចំណុចចុងក្រោយដោយចុចពីរដង ដើម្បីបញ្ចប់។"
        },
        {
          "title": "មើលក្រាហ្វ",
          "caption": "ក្រាហ្វផ្នែកបណ្ដោយដែលកាត់តាមបន្ទាត់ដែលបានគូស បើកនៅខាងក្រោម។"
        }
      ]
    },
    "t-pf-view": {
      "title": "ការប្រើក្រាហ្វ (1) ការបញ្ជា",
      "steps": [
        {
          "title": "បើក [របៀបផ្នែក]",
          "caption": "នេះជាក្រាហ្វដែលបានបើកក្នុង [ពិនិត្យផ្នែកបញ្ហាបន្ទាត់ (3D)]។ បន្ទាត់ដែលមានកំពូលបី ឬច្រើនជាងនេះ អាចមើលម្ដងមួយផ្នែកដោយ [របៀបផ្នែក]។ បើក [របៀបផ្នែក]។"
        },
        {
          "title": "ចុច [ចន្លោះបន្ទាប់]",
          "caption": "មានតែចន្លោះទីមួយ (P1–P2) បង្ហាញលើក្រាហ្វ។ ចុច [ចន្លោះបន្ទាប់]។"
        },
        {
          "title": "រំកិលកង់ដើម្បីពង្រីក",
          "caption": "ប្ដូរទៅចន្លោះបន្ទាប់ (P2–P3)។ រំកិលកង់លើក្រាហ្វ វានឹងពង្រីកជុំវិញទីតាំងទស្សន៍ទ្រនិច។"
        },
        {
          "title": "អូសដើម្បីផ្លាស់ទី",
          "caption": "ក្រាហ្វត្រូវបានពង្រីក។ អូសក្រាហ្វទៅចំហៀង។"
        },
        {
          "title": "ចុច [បន្ថែមទៀត]",
          "caption": "ក្រាហ្វបានផ្លាស់ទី។ ឧបករណ៍ដែលមិនសមនឹងក្បាលផ្ទាំង ត្រូវបានប្រមូលនៅ [បន្ថែមទៀត]។ ចុច [បន្ថែមទៀត]។"
        },
        {
          "title": "ចុច [កំណត់ការបង្ហាញឡើងវិញ]",
          "caption": "ចុច [កំណត់ការបង្ហាញឡើងវិញ] ដើម្បីត្រឡប់ទៅចន្លោះដំបូង។"
        },
        {
          "title": "អូសដៃចាប់ដើម្បីពង្រីកក្រាហ្វ",
          "caption": "ក្រាហ្វត្រឡប់ទៅចន្លោះដំបូងវិញ។ អូសដៃចាប់នៅខាងលើផ្ទាំងឡើងលើ ផ្ទៃក្រាហ្វនឹងធំឡើង។"
        },
        {
          "title": "ចុច [បន្ថែមទៀត]",
          "caption": "ផ្ទៃក្រាហ្វធំឡើង។ ចុច [បន្ថែមទៀត] ម្ដងទៀត។"
        },
        {
          "title": "អូសរបារ [តម្លាភាព]",
          "caption": "អូសរបារ [តម្លាភាព] ទៅស្ដាំ។"
        },
        {
          "title": "ដាក់ [តម្លាភាព] ត្រឡប់វិញ",
          "caption": "ផ្ទាំងក្រាហ្វក្លាយជាថ្លា ហើយម៉ូដែល 3D នៅពីក្រោយបង្ហាញឡើង។ អូសរបារត្រឡប់ទៅចុងខាងឆ្វេងវិញ។"
        },
        {
          "title": "ចុច [ស្បែករចនាបទងងឹត]",
          "caption": "ផ្ទាំងលែងថ្លាវិញ។ ចុច [ស្បែករចនាបទងងឹត] ក្នុងម៉ឺនុយដដែល។"
        },
        {
          "title": "ចុច [ពេញអេក្រង់]",
          "caption": "ផ្ទៃខាងក្រោយប្ដូរជាពណ៌ងងឹត។ ចុច [ពេញអេក្រង់] នៅជ្រុងខាងស្ដាំខាងលើនៃក្រាហ្វ ដើម្បីមើលតែក្រាហ្វពេញអេក្រង់។"
        },
        {
          "title": "ចុចលើខ្សែក្រាហ្វ",
          "caption": "ចុចលើខ្សែក្រាហ្វ ចំណុចនោះនឹងត្រូវបានកំណត់ ហើយជួរខាងក្រោមបង្ហាញកូអរដោនេ X·Y·Z។"
        },
        {
          "title": "ចុចប្រអប់ប្រព័ន្ធកូអរដោនេ",
          "caption": "ចុចប្រអប់ប្រព័ន្ធកូអរដោនេ (Korea2000)។"
        },
        {
          "title": "ជ្រើស [WGS84]",
          "caption": "ជ្រើស [WGS84] ពី Google Mercator·WGS84·UTM។"
        },
        {
          "title": "ចុច [ចម្លងកូអរដោនេ]",
          "caption": "តម្លៃប្ដូរជារយៈបណ្ដោយ·រយៈទទឹង·កម្ពស់។ ចុច [ចម្លងកូអរដោនេ] នៅខាងស្ដាំ។"
        },
        {
          "title": "មើល [បានចម្លង]",
          "caption": "[បានចម្លង] បង្ហាញឡើង ហើយកូអរដោនេត្រូវបានចម្លង។"
        }
      ]
    },
    "t-pf-layers": {
      "title": "ការប្រើក្រាហ្វ (2) ប្រៀបធៀបស្រទាប់",
      "note": "ផ្ទៃគំនូរបច្ចេកទេសក្នុងក្រុម [គម្រោង] បង្ហាញឡើង ពេលផ្ទុកគំនូរបច្ចេកទេសឡើងក្នុង <a href=\"#t-terrain\">ទិន្នន័យកម្ពស់ភូមិសាស្ត្រ</a>។",
      "steps": [
        {
          "title": "ចុច [ស្រទាប់]",
          "caption": "នេះជាក្រាហ្វផ្នែកឆ្លង។ ចុច [ស្រទាប់] (4) នៅជ្រុងខាងឆ្វេងខាងលើ។"
        },
        {
          "title": "ពង្រីក [Mesh បច្ចុប្បន្ន]",
          "caption": "មានក្រុម Mesh បច្ចុប្បន្ន·BIM·Point Cloud·គម្រោង·ស្រទាប់ដី·វ៉ិចទ័រ។ ពង្រីក [Mesh បច្ចុប្បន្ន]។"
        },
        {
          "title": "បើកថ្ងៃថតមួយទៀត",
          "caption": "មាន Mesh សម្រាប់ថ្ងៃថតនីមួយៗ។ បើក 2024-01-25។"
        },
        {
          "title": "រំកិលបញ្ជីចុះក្រោម",
          "caption": "ផ្នែកកាត់នៃថ្ងៃថតទាំងពីរ ត្រួតគ្នាដោយពណ៌ខុសគ្នា (នៅ 01-25 កន្លែងជីកនៅតែគ្របដណ្ដប់)។ រំកិលបញ្ជីចុះក្រោម។"
        },
        {
          "title": "ពង្រីក [គម្រោង]",
          "caption": "ក្រុម [គម្រោង] នៅខាងក្រោម។ ពង្រីក [គម្រោង]។"
        },
        {
          "title": "បើក [កម្ពស់គម្រោង]",
          "caption": "មានផ្ទៃគំនូរបច្ចេកទេស (កម្ពស់ដីដើម·កម្ពស់គម្រោង)។ បើក [កម្ពស់គម្រោង]។"
        },
        {
          "title": "បើក [កម្ពស់ដីដើម]",
          "caption": "បាតជីកតាមគម្រោង (កម្ពស់គម្រោង) ត្រូវបានគូស។ បើក [កម្ពស់ដីដើម] ផងដែរ។"
        },
        {
          "title": "ចុច [ដើម]",
          "caption": "ផ្ទៃដីមុនជីក (កម្ពស់ដីដើម) ក៏បង្ហាញជាមួយស្ថានភាពបច្ចុប្បន្នដែរ។ ក្នុង [របៀបពណ៌] ចុច [ដើម]។"
        },
        {
          "title": "មើលជាពណ៌ពិត",
          "caption": "ខ្សែស្ថានភាពបច្ចុប្បន្ន ត្រូវបានលាបពណ៌ពិតនៃម៉ូដែល។"
        }
      ]
    },
    "t-pf-measure": {
      "title": "ការប្រើក្រាហ្វ (3) ការវាស់",
      "steps": [
        {
          "title": "ចុច [វាស់បន្ទាត់]",
          "caption": "វាស់កន្លែងជីក ក្នុងផ្នែកឆ្លងនៃចំណុចស្ទង់ 040។ ក្នុង [គូរ] ចុច [វាស់បន្ទាត់]។"
        },
        {
          "title": "ចុចជ្រុងខាងឆ្វេងខាងលើ",
          "caption": "ចុចលើខ្សែផ្នែកកាត់ ដើម្បីដាក់ចំណុច។ ចុចជ្រុងខាងឆ្វេងខាងលើនៃកន្លែងជីក។"
        },
        {
          "title": "ដាក់ចំណុចលើបាត",
          "caption": "ចុចបាតកន្លែងជីក (ក្រោមជញ្ជាំងបន្តិច)។ បន្ទាត់ចុចៗ និងប្រវែង តាមទស្សន៍ទ្រនិចពីចំណុចចុងក្រោយ។"
        },
        {
          "title": "ចុចកណ្ដុរស្ដាំដើម្បីបញ្ចប់",
          "caption": "ចុចកណ្ដុរស្ដាំលើក្រាហ្វ ការវាស់នឹងបញ្ចប់។"
        },
        {
          "title": "ចុច [វាស់ចំណុច]",
          "caption": "ប្រវែងចន្លោះ (ជម្រៅជីក) បង្ហាញឡើង ហើយប្រអប់កូអរដោនេបង្ហាញនៅចំណុចនីមួយៗ។ ចុច [វាស់ចំណុច]។"
        },
        {
          "title": "ចុចចុងខាងស្ដាំនៃបាត",
          "caption": "ចុចចំណុចមួយលើខ្សែផ្នែកកាត់ កូអរដោនេនៃចំណុចនោះនឹងបង្ហាញ។ ចុចចុងខាងស្ដាំនៃបាតកន្លែងជីក។"
        },
        {
          "title": "ចុច [ស្លាក: ថេរ]",
          "caption": "ប្រអប់កូអរដោនេនៃចំណុចបង្ហាញឡើង។ បើប្រអប់បាំងប្រវែង ចុច [ស្លាក: ថេរ] ដើម្បីប្ដូរទៅ [ហូវ]។"
        },
        {
          "title": "ចុច [វាស់ក្រឡាចត្រង្គ]",
          "caption": "ប្រអប់កូអរដោនេ បង្ហាញតែពេលដាក់កណ្ដុរលើចំណុច ហើយនៅសល់តែប្រវែង។ ចុច [វាស់ក្រឡាចត្រង្គ]។"
        },
        {
          "title": "ចុចជ្រុងទីមួយ",
          "caption": "ចុចចុងទាំងពីរនៃអង្កត់ទ្រូងរបស់ចតុកោណកែងតាមលំដាប់។ ចុចជ្រុងខាងឆ្វេងខាងលើនៃបំពង់ខាងស្ដាំ។"
        },
        {
          "title": "ចុចជ្រុងទល់មុខ",
          "caption": "ចុចជ្រុងខាងស្ដាំខាងក្រោមនៃបំពង់ (បាតកន្លែងជីក)។"
        },
        {
          "title": "ចុច [វាស់រង្វង់]",
          "caption": "ទទឹង·កម្ពស់·អង្កត់ទ្រូងនៃបំពង់ បង្ហាញឡើង។ ចុច [វាស់រង្វង់]។"
        },
        {
          "title": "ចុចផ្ចិតរង្វង់",
          "caption": "ចុចផ្ចិតរង្វង់មុន។ ចុចកណ្ដាលបំពង់ខាងឆ្វេង។"
        },
        {
          "title": "ចុចគែមរង្វង់",
          "caption": "ចុចផ្ទៃខាងលើនៃបំពង់។"
        },
        {
          "title": "ចុច [វាស់អ័ក្ស]",
          "caption": "កាំ (R) បង្ហាញឡើង។ ចុច [វាស់អ័ក្ស]។"
        },
        {
          "title": "ចុចចំណុចមួយក្រោមផ្លូវ",
          "caption": "វាបង្ហាញជាមុននូវចំណុចដែលខ្សែផ្ដេក·បញ្ឈរកាត់តាមទស្សន៍ទ្រនិច ប្រសព្វនឹងខ្សែផ្នែកកាត់។ ចុចក្រោមផ្លូវ នៅខាងស្ដាំកន្លែងជីក។"
        },
        {
          "title": "ចុច [លុបការវាស់]",
          "caption": "ចម្ងាយរវាងចំណុចប្រសព្វ បង្ហាញឡើង។ ចុច [លុបការវាស់]។"
        },
        {
          "title": "ចុច [លុបទាំងអស់]",
          "caption": "[ជ្រើសរើសលុប] លុបតែការវាស់ដែលចុច ហើយ [លុបទាំងអស់] លុបទាំងអស់។ ចុច [លុបទាំងអស់]។"
        },
        {
          "title": "មើលក្រាហ្វដែលបានលុបការវាស់",
          "caption": "ការវាស់ទាំងអស់លើក្រាហ្វ ត្រូវបានលុប។"
        }
      ]
    },
    "t-pf-image": {
      "title": "ការប្រើក្រាហ្វ (4) ចាប់យក·ទាញយក",
      "steps": [
        {
          "title": "ចុច [ចាប់យករូបភាព]",
          "caption": "ដើម្បីរក្សាទុកក្រាហ្វជាឯកសាររូបភាព ចុច [ចាប់យករូបភាព]។"
        },
        {
          "title": "ជ្រើស [PNG]",
          "caption": "ជ្រើសទម្រង់ពី PNG·JPG·JPEG·WEBP។ ចុច [PNG]។"
        },
        {
          "title": "ចុច [ទាញយកតាមគម្លាតចំណុច]",
          "caption": "រូបភាពក្រាហ្វត្រូវបានទាញយកជាឯកសារ PNG។ ដើម្បីទទួលតម្លៃកម្ពស់ជាឯកសារ ចុច [ទាញយកតាមគម្លាតចំណុច]។"
        },
        {
          "title": "បញ្ចូល 2 ជាគម្លាតចំណុច",
          "caption": "បង្អួច [ទាញយកទិន្នន័យ] បើកឡើង ហើយខ្សែក្រាហ្វប្ដូរជាខ្សែភ្ជាប់ចំណុច ដែលយកតាម [គម្លាតចំណុច] នីមួយៗ។ បញ្ចូល 2 ជាគម្លាតចំណុច។"
        },
        {
          "title": "ជ្រើសទម្រង់ CSV",
          "caption": "ខ្សែត្រូវបានគូសឡើងវិញ តាមចំណុចដែលឃ្លាតគ្នា 2 m។ ពីទម្រង់ (TXT·CSV·DXF) ចុច CSV។"
        },
        {
          "title": "ចុច [បញ្ជាក់]",
          "caption": "បង្អួចបញ្ជាក់ បង្ហាញស្រទាប់ និងគម្លាតចំណុច ដែលនឹងដាក់ក្នុងឯកសារ។ ចុច [បញ្ជាក់] ឯកសារនឹងត្រូវបានទាញយក។"
        }
      ]
    },
    "t-pf-qty": {
      "title": "ការប្រើក្រាហ្វ (5) តារាងបរិមាណ",
      "steps": [
        {
          "title": "ចុច [តារាងបរិមាណ]",
          "caption": "នេះជាផ្នែកឆ្លង ដែលបើកកម្ពស់គម្រោង·កម្ពស់ដីដើមនៃគំនូរបច្ចេកទេស។ ចុច [តារាងបរិមាណ]។"
        },
        {
          "title": "ចុច [ទាញយក Excel]",
          "caption": "នេះជាបង្អួច [តារាងបរិមាណផ្នែកឆ្លង]។ វាបង្ហាញកម្ពស់ដីដើម·កម្ពស់គម្រោង·កម្ពស់បច្ចុប្បន្ន នៃចំណុចស្ទង់នេះ និងផ្ទៃចាក់ដី·កាប់ដី ជាគម្រោង (ខៀវ) និងវឌ្ឍនភាព (បៃតង)។ ចុច [ទាញយក Excel] តារាងនឹងត្រូវបានទាញយកជាឯកសារ។"
        }
      ]
    },
    "t-camera": {
      "title": "ការបញ្ជាកាមេរ៉ា",
      "note": "ការចុចពីរដងដើម្បីខិតទៅជិតចំណុចនោះ ដំណើរការតែពេលមិនបានជ្រើសឧបករណ៍។ ដូចការណែនាំខាងស្ដាំក្រោម អូសដោយប៊ូតុងឆ្វេងដើម្បីផ្លាស់ទីស្រប អូសដោយប៊ូតុងស្ដាំដើម្បីបង្វិល និងផ្អៀង ហើយរមូរដើម្បីពង្រីក ឬបង្រួម។",
      "steps": [
        {
          "title": "ចុច [3D]",
          "caption": "ចុច [3D] នៅរបារខាងឆ្វេងនៃអេក្រង់ត្រួតពិនិត្យ 2D។"
        },
        {
          "title": "រមូរដើម្បីខិតជិត",
          "caption": "ម៉ូដែល 3D នៃថ្ងៃថតដដែល បើកឡើងជាទិដ្ឋភាពមើលពីលើចុះក្រោម។ រមូរកង់កណ្ដុរឡើងលើ ដើម្បីខិតជិត។"
        },
        {
          "title": "ផ្អៀងដោយប៊ូតុងស្ដាំ",
          "caption": "បានខិតជិតម៉ូដែលហើយ។ ចុចប៊ូតុងស្ដាំឱ្យជាប់ ហើយអូសឡើងលើ ដើម្បីផ្អៀង។"
        },
        {
          "title": "បង្វិលដោយប៊ូតុងស្ដាំ",
          "caption": "ទិដ្ឋភាពក្លាយជាមើលចុះក្រោមពីចំហៀង។ ចុចប៊ូតុងស្ដាំឱ្យជាប់ ហើយអូសទៅចំហៀង ដើម្បីបង្វិល។"
        },
        {
          "title": "ផ្លាស់ទីដោយប៊ូតុងឆ្វេង",
          "caption": "ទិសដៅបានបង្វិលហើយ។ ចុចប៊ូតុងឆ្វេងឱ្យជាប់ ហើយអូស ដើម្បីផ្លាស់ទីម៉ូដែល។"
        },
        {
          "title": "ចុច [ផ្លាស់ប្ដូរពណ៌ផ្ទៃខាងក្រោយ]",
          "caption": "ក្នុង [ផ្សេងៗ] ចុច [ផ្លាស់ប្ដូរពណ៌ផ្ទៃខាងក្រោយ]។"
        },
        {
          "title": "ជ្រើសពណ៌ផ្ទៃខាងក្រោយ",
          "caption": "បញ្ជីពណ៌បើកឡើង។ ជ្រើសពណ៌ផ្ទៃខាងក្រោយ។"
        },
        {
          "title": "ចុចពីរដងដើម្បីខិតជិត",
          "caption": "ផ្ទៃខាងក្រោយជុំវិញម៉ូដែល ប្ដូរទៅពណ៌ដែលបានជ្រើស។ ចុចពីរដងលើកន្លែងដែលចង់មើល ដើម្បីខិតទៅជិតចំណុចនោះ។"
        },
        {
          "title": "ចុច [TOP]",
          "caption": "បានខិតជិតចំណុចនោះហើយ។ ចុច [TOP] លើគូបទិសដៅ ខាងស្ដាំលើ។"
        },
        {
          "title": "មើលពីលើ",
          "caption": "ទិដ្ឋភាពប្ដូរទៅមើលពីលើចុះក្រោមត្រង់។"
        }
      ]
    },
    "t-fly": {
      "title": "ការហោះក្នុងទិដ្ឋភាពទីមួយ",
      "steps": [
        {
          "title": "ចុច [ប្ដូរទៅទិដ្ឋភាពទីមួយ]",
          "caption": "ចុច [ប្ដូរទៅទិដ្ឋភាពទីមួយ] នៅខាងស្ដាំក្រោម។"
        },
        {
          "title": "បន្តពីទំព័រទី 1 នៃការបញ្ជា",
          "caption": "ផ្ទាំង [ការបញ្ជាទិដ្ឋភាពទីមួយ] បើកឡើង។ ផ្លាស់ទីដោយ W·A·S·D ហើយចុចពីរដងដើម្បីទៅលឿន។ ចុច [បន្ទាប់]។"
        },
        {
          "title": "បន្តពីទំព័រទី 2 នៃការបញ្ជា",
          "caption": "ទំព័រទី 2 — ចុច Space ដើម្បីឡើង និង Shift ដើម្បីចុះ។ ចុច [បន្ទាប់]។"
        },
        {
          "title": "ចុច [ចាប់ផ្ដើម]",
          "caption": "ទំព័រទី 3 — រមូរដើម្បីពង្រីក ឬបង្រួម ហើយចុចស្ដាំដើម្បីចេញ។ ចុច [ចាប់ផ្ដើម]។"
        },
        {
          "title": "ចុច W ឱ្យជាប់ដើម្បីទៅមុខ",
          "caption": "នេះជាទិដ្ឋភាពទីមួយ។ សញ្ញាគោលដៅបង្ហាញនៅកណ្ដាល ហើយការណែនាំគ្រាប់ចុចនៅខាងស្ដាំក្រោម។ ផ្លាស់ទីកណ្ដុរដើម្បីបង្វិលទិដ្ឋភាព ហើយចុច W ឱ្យជាប់ ដើម្បីទៅមុខ។"
        },
        {
          "title": "ចុចស្ដាំដើម្បីចេញ",
          "caption": "បានទៅមុខហើយ។ ចុចស្ដាំ (ឬ Esc) ដើម្បីចេញពីទិដ្ឋភាពទីមួយ។"
        },
        {
          "title": "ត្រឡប់ទៅការបញ្ជាធម្មតា",
          "caption": "បានត្រឡប់មកការបញ្ជាធម្មតា ដែលផ្លាស់ទីដោយការអូស និងការរមូរ។"
        }
      ]
    },
    "t-3dlayer": {
      "title": "ស្រទាប់ 3D",
      "note": "ស្រទាប់ GIS·បន្ទាត់·BIM·Point Cloud ផ្ទុកឡើងនៅ <a href=\"#t-layerdata\">ទិន្នន័យស្រទាប់</a>។",
      "steps": [
        {
          "title": "បើក [LAYER]",
          "caption": "ចុច [LAYER] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "បើក [DSM]",
          "caption": "នេះជាផ្ទាំងស្រទាប់ 3D។ បើក [DSM]។"
        },
        {
          "title": "មើលពណ៌តាមកម្ពស់",
          "caption": "ម៉ូដែលត្រូវបានលាបពណ៌តាមកម្ពស់ ហើយមានតារាងសម្គាល់ Lowest–Highest នៅក្រោម DSM។"
        },
        {
          "title": "បិទ [DSM]",
          "caption": "បិទ [DSM]។"
        },
        {
          "title": "អូសរបារភាពថ្លា",
          "caption": "អូសរបារ [ភាពថ្លា] នៃ [Mesh] ដើម្បីធ្វើឱ្យម៉ូដែលថ្លាពាក់កណ្ដាល។"
        },
        {
          "title": "ត្រឡប់ភាពថ្លាវិញ",
          "caption": "ម៉ូដែលថ្លាពាក់កណ្ដាល ហើយអាចមើលឃើញផ្នែកខាងក្រោយ។ អូសរបារទៅចុងខាងឆ្វេងវិញ។"
        },
        {
          "title": "បើក [ចំណារ]",
          "caption": "ម៉ូដែលលែងថ្លាវិញហើយ។ បើក [ចំណារ]។"
        },
        {
          "title": "មើលបញ្ហា",
          "caption": "បញ្ហាត្រូវបានគូរលើម៉ូដែល។"
        },
        {
          "title": "ពង្រីក [ស្រទាប់លីនេអ៊ែរ]",
          "caption": "ពង្រីក [ស្រទាប់លីនេអ៊ែរ]។"
        },
        {
          "title": "បើកខ្សែផ្លូវគម្រោង",
          "caption": "នេះជាបញ្ជីស្រទាប់លីនេអ៊ែរ។ បើកខ្សែផ្លូវគម្រោង។"
        },
        {
          "title": "មើលខ្សែផ្លូវដែលបានគូរ",
          "caption": "ខ្សែផ្លូវគម្រោងត្រូវបានគូរលើម៉ូដែល។"
        },
        {
          "title": "ចុច [ផ្លាស់ទីទៅម៉ូដែល]",
          "caption": "ចុចប៊ូតុងគោលដៅ ([ផ្លាស់ទីទៅម៉ូដែល]) នៅខាងស្ដាំ [Mesh]។"
        },
        {
          "title": "មើលម៉ូដែលទាំងមូល",
          "caption": "ទិដ្ឋភាពផ្លាស់ទីទៅមើលពីលើ ដើម្បីឱ្យឃើញម៉ូដែលទាំងមូល។"
        }
      ]
    },
    "t-measure3d": {
      "title": "ការវាស់ចម្ងាយ និងបញ្ឈរ",
      "note": "ការវាស់មិនត្រូវបានរក្សាទុកទេ ហើយនឹងលុបចោលពេលប្ដូរស៊េរីពេលវេលាយោង។",
      "steps": [
        {
          "title": "ជ្រើស [វាស់ចម្ងាយ]",
          "caption": "ក្នុង [វាស់] ជ្រើស [វាស់ចម្ងាយ]។"
        },
        {
          "title": "ដាក់ចំណុចទីមួយ",
          "caption": "ចុចលើម៉ូដែល ដើម្បីដាក់ចំណុចទីមួយ។ ចុចម្ដងៗ ចំណុចកើនឡើង ហើយចុចពីរដងដើម្បីបញ្ចប់។"
        },
        {
          "title": "ដាក់ចំណុចបន្ទាប់",
          "caption": "ដាក់ចំណុចបន្ទាប់។ ផ្នែកនីមួយៗបង្ហាញចម្ងាយ 3D។"
        },
        {
          "title": "ចុចពីរដងដើម្បីបញ្ចប់",
          "caption": "ដាក់ចំណុចចុងក្រោយដោយចុចពីរដង ដើម្បីបញ្ចប់។"
        },
        {
          "title": "មើលចម្ងាយតាមផ្នែក",
          "caption": "ការវាស់ចម្ងាយបានបញ្ចប់។ ផ្នែកនីមួយៗបង្ហាញចម្ងាយ 3D។"
        },
        {
          "title": "ជ្រើស [វាស់បញ្ឈរ]",
          "caption": "លើកនេះ វាស់ជម្រៅកន្លែងជីក។ ក្នុង [វាស់] ជ្រើស [វាស់បញ្ឈរ]។"
        },
        {
          "title": "ដាក់ចំណុចខាងលើ",
          "caption": "ចុចផ្ទៃផ្លូវ នៅក្បែរកន្លែងជីក។"
        },
        {
          "title": "ដាក់ចំណុចខាងក្រោម",
          "caption": "ចុចបាតកន្លែងជីក ការវាស់នឹងបញ្ចប់។"
        },
        {
          "title": "មើលកម្ពស់ ផ្ដេក និងចម្ងាយ 3D",
          "caption": "កម្ពស់ (បញ្ឈរ) ចម្ងាយផ្ដេក និងចម្ងាយ 3D រវាងចំណុចទាំងពីរ បង្ហាញជាមួយគ្នា។"
        }
      ]
    },
    "t-area3d": {
      "title": "ការវាស់ផ្ទៃ និងប្រវែងបណ្ដោយ",
      "note": "ក្រាហ្វនៃការវាស់ប្រវែងបណ្ដោយ គឺជាអេក្រង់ដូចគ្នានឹងក្រាហ្វក្នុងជំពូក <a href=\"#c6\">ក្រាហ្វផ្នែកកាត់</a>។",
      "steps": [
        {
          "title": "ជ្រើស [វាស់ផ្ទៃ]",
          "caption": "ក្នុង [វាស់] ជ្រើស [វាស់ផ្ទៃ]។"
        },
        {
          "title": "ដាក់កំពូលទីមួយ",
          "caption": "ចុចលើម៉ូដែល ដើម្បីដាក់កំពូលទីមួយ។"
        },
        {
          "title": "ដាក់កំពូលទីពីរ",
          "caption": "ដាក់កំពូលបន្ទាប់។"
        },
        {
          "title": "ដាក់កំពូលទីបី",
          "caption": "ជ្រុងមួយកើតឡើងជាមួយចម្ងាយ។ ដាក់កំពូលបន្ទាប់។"
        },
        {
          "title": "ដាក់កំពូលទីបួន",
          "caption": "ពេលមានកំពូលបី ផ្ទៃក្រឡាបង្ហាញឡើង។ ដាក់កំពូលបន្ទាប់។"
        },
        {
          "title": "ចុចពីរដងដើម្បីបញ្ចប់",
          "caption": "ដាក់កំពូលចុងក្រោយដោយចុចពីរដង ដើម្បីបញ្ចប់។"
        },
        {
          "title": "មើលផ្ទៃក្រឡា",
          "caption": "ការវាស់ផ្ទៃបានបញ្ចប់។ ផ្ទៃក្រឡា 3D និងផ្ទៃក្រឡាប្លង់ បង្ហាញនៅកណ្ដាល ហើយជ្រុងនីមួយៗមានចម្ងាយ។"
        },
        {
          "title": "ជ្រើស [វាស់ប្រវែងបណ្ដោយ]",
          "caption": "ជ្រើស [វាស់ប្រវែងបណ្ដោយ]។"
        },
        {
          "title": "ដាក់ចំណុចចាប់ផ្ដើម",
          "caption": "ចុចចំណុចចាប់ផ្ដើមនៃបន្ទាត់។"
        },
        {
          "title": "ចុចពីរដងលើចំណុចបញ្ចប់",
          "caption": "ចុចពីរដងលើចំណុចបញ្ចប់។"
        },
        {
          "title": "មើលក្រាហ្វកម្ពស់",
          "caption": "ក្រាហ្វកម្ពស់ដែលវាស់តាមបន្ទាត់ បើកនៅខាងក្រោម។ កន្លែងជីក និងបំពង់ បង្ហាញជាផ្នែកកាត់។"
        },
        {
          "title": "ជ្រើស [ជ័រលុបការវាស់]",
          "caption": "ជ្រើស [ជ័រលុបការវាស់]។"
        },
        {
          "title": "ចុចការវាស់ដែលត្រូវលុប",
          "caption": "ចុចការវាស់ដែលត្រូវលុប (ផ្ទៃ)។"
        },
        {
          "title": "មើលកន្លែងដែលបានលុប",
          "caption": "ការវាស់ផ្ទៃត្រូវបានលុប។ ការវាស់មិនត្រូវបានរក្សាទុកទេ ដូច្នេះវាបាត់ពេលបើកអេក្រង់ម្ដងទៀត។"
        }
      ]
    },
    "t-issue3d": {
      "title": "បញ្ហា 3D",
      "note": "បន្ទាត់ ចតុកោណ ពហុកោណ និងអក្សរ ក៏បង្កើតពី [បង្កើត] ដែរ៖ ចំណុច និងអក្សរបញ្ចប់នៅការចុចលើកទីមួយ ចតុកោណនៅការចុចលើកទីពីរ ហើយបន្ទាត់ និងពហុកោណនៅការចុចពីរដង។ បើចុច [ផ្លាស់ទីទៅបញ្ហា] លើបញ្ហាដែលមិនមាននៅថ្ងៃថតបច្ចុប្បន្ន ផ្ទាំង [បញ្ហាមិនមាននៅក្នុងស៊េរីពេលវេលាបច្ចុប្បន្ន] នឹងបើកឡើង។",
      "steps": [
        {
          "title": "ជ្រើសឧបករណ៍ [ចំណុច]",
          "caption": "ក្នុង [បង្កើត] ជ្រើស [ចំណុច]។"
        },
        {
          "title": "ចុចលើម៉ូដែល",
          "caption": "បើស្រទាប់បញ្ហាត្រូវបានបិទ វានឹងបើកដោយស្វ័យប្រវត្តិ ហើយមានការជូនដំណឹង។ ចុចលើម៉ូដែល នៅកន្លែងដែលចង់ដាក់បញ្ហា។"
        },
        {
          "title": "មើលព័ត៌មានបញ្ហា",
          "caption": "បញ្ហាត្រូវបានរក្សាទុកភ្លាមៗជា [បញ្ហា N] ហើយ [ព័ត៌មានបញ្ហា] បើកនៅខាងឆ្វេង។ ប្ដូរឈ្មោះ ប្រភេទ កម្រិត និងកំណត់ចំណាំ ដោយ [កែ]។"
        },
        {
          "title": "បើក [ISSUE]",
          "caption": "ចុច [ISSUE] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "ពង្រីកក្រុមប្រភេទ",
          "caption": "បញ្ហាត្រូវបានដាក់ជាក្រុមតាមប្រភេទ។ ពង្រីកក្រុមប្រភេទមួយ។"
        },
        {
          "title": "ចុច [ផ្លាស់ទីទៅបញ្ហា]",
          "caption": "ចុច [ផ្លាស់ទីទៅបញ្ហា] នៅជួរនៃបញ្ហាដែលចង់មើល។"
        },
        {
          "title": "ចុច [បង្ហាញឈ្មោះបញ្ហា]",
          "caption": "កាមេរ៉ាផ្លាស់ទីទៅបញ្ហានោះ ហើយ [ព័ត៌មានបញ្ហា] បើកឡើង។ ក្នុង [ផ្សេងៗ] ចុច [បង្ហាញឈ្មោះបញ្ហា]។"
        },
        {
          "title": "មើលឈ្មោះដែលបានលាក់",
          "caption": "ឈ្មោះបញ្ហាលើម៉ូដែលត្រូវបានលាក់។ ចុចម្ដងទៀត ដើម្បីបង្ហាញវិញ។"
        }
      ]
    },
    "t-clip": {
      "title": "បង្កើតមុខកាត់",
      "note": "អាចបើកមុខកាត់ក្នុងពេលតែមួយបានរហូតដល់ 8។ ប្ដូរឈ្មោះដោយប៊ូតុងខ្មៅដៃក្នុងបញ្ជី ហើយលុបដោយប៊ូតុងដក (មុខកាត់ដែលបានលុប មិនអាចស្ដារវិញបានទេ)។",
      "steps": [
        {
          "title": "បើក [CLIP]",
          "caption": "ចុច [CLIP] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "បញ្ចូល [ជ្រុង]",
          "caption": "[ឧបករណ៍មុខកាត់] បើកឡើង ហើយ [ប្រអប់] ត្រូវបានជ្រើសក្នុង [បន្ថែមមុខកាត់]។ បញ្ចូលប្រវែងជ្រុងប្រអប់ (m) ក្នុង [ជ្រុង]។"
        },
        {
          "title": "បញ្ចូលឈ្មោះ",
          "caption": "បញ្ចូលឈ្មោះ។ បើទុកទទេ នឹងដាក់លេខរៀងដូចជា [ប្រអប់ 1]។"
        },
        {
          "title": "ចុច [បន្ថែមដោយចុចលើផ្ទៃ]",
          "caption": "ចុច [បន្ថែមដោយចុចលើផ្ទៃ]។"
        },
        {
          "title": "ចុចទីតាំងប្រអប់",
          "caption": "[ចុចលើផ្ទៃម៉ូដែលក្នុងទិដ្ឋភាព 3D] បង្ហាញឡើង។ ចុចលើម៉ូដែល នៅកន្លែងដែលនឹងក្លាយជាកណ្ដាលប្រអប់។ ចុចស្ដាំ ឬ Esc ដើម្បីបោះបង់។"
        },
        {
          "title": "បិទដោយកុងតាក់",
          "caption": "នៅសល់តែផ្នែកខាងក្នុងប្រអប់ ផ្នែកផ្សេងត្រូវបានលាក់។ ប្រអប់បន្ថែមចូល [បញ្ជីមុខកាត់] ហើយត្រូវបានរក្សាទុកភ្លាមៗ។ ប្រើកុងតាក់ក្នុងបញ្ជី ដើម្បីបើក និងបិទមុខកាត់។"
        },
        {
          "title": "ជ្រើស [ប្លង់]",
          "caption": "មុខកាត់ត្រូវបានបិទ ហើយឃើញម៉ូដែលទាំងមូល។ បើបើកម្ដងទៀត កាមេរ៉ានឹងផ្លាស់ទីទៅមុខកាត់នោះ។ លើកនេះ ជ្រើស [ប្លង់]។"
        },
        {
          "title": "ចុច [បន្ថែមដោយចុចលើផ្ទៃ]",
          "caption": "ចុច [បន្ថែមដោយចុចលើផ្ទៃ]។"
        },
        {
          "title": "ចុចទីតាំងប្លង់",
          "caption": "ចុចលើម៉ូដែល នៅកន្លែងដែលប្លង់ត្រូវឆ្លងកាត់។"
        },
        {
          "title": "មើលប្លង់ផ្ដេក",
          "caption": "ប្លង់ផ្ដេកទំហំ [ជ្រុង] កើតឡើងនៅកម្ពស់ដែលបានចុច ហើយនៅសល់តែផ្នែកខាងលើវា។ វិធីបញ្ឈរប្លង់ ដើម្បីមើលមុខកាត់បញ្ឈរ មាននៅក្នុង [កែតម្រូវ និងរក្សាទុកមុខកាត់]។"
        }
      ]
    },
    "t-clipedit": {
      "title": "កែតម្រូវ និងរក្សាទុកមុខកាត់",
      "note": "យ៉យស្ទីក [បញ្ឈរ] ផ្លាស់ទីឡើងចុះ ហើយយ៉យស្ទីកទីបី ប្ដូរ [គម្លាត] (កម្ពស់) សម្រាប់ប្រអប់ ឬ [ផ្ទៃក្រឡា] (ទំហំ) សម្រាប់ប្លង់។",
      "steps": [
        {
          "title": "ពង្រីកប្លង់",
          "caption": "ចុចប្លង់ក្នុងបញ្ជី ដើម្បីពង្រីក។"
        },
        {
          "title": "ចុច [កែសម្រួល]",
          "caption": "[គែម] បើក ឬបិទគែមមុខកាត់ ហើយ [បំពេញមុខកាត់] បើក ឬបិទពណ៌លើផ្ទៃកាត់។ [បញ្ច្រាស] ប្ដូរផ្នែកដែលនៅសល់។ ចុច [កែសម្រួល]។"
        },
        {
          "title": "អូស [ភាពទេរ]",
          "caption": "ពេលកែសម្រួល អាចអូសកំពូល និងផ្ទៃក្នុងទិដ្ឋភាព 3D ដោយផ្ទាល់ ឬប្រើយ៉យស្ទីក និងរបារខាងក្រោម។ អូសរបារ [ភាពទេរ] ទៅចុងខាងឆ្វេង ដើម្បីបញ្ឈរប្លង់។"
        },
        {
          "title": "អូសយ៉យស្ទីក [ផ្ដេក]",
          "caption": "ប្លង់ឈរឡើង ហើយបង្ហាញមុខកាត់ឆ្លងកាត់កន្លែងជីក។ ចុចយ៉យស្ទីក [ផ្ដេក] ឱ្យជាប់ ហើយអូស វានឹងផ្លាស់ទីទៅទិសនោះជាបន្តបន្ទាប់ ហើយឈប់ពេលលែងដៃ។"
        },
        {
          "title": "មើលមុខកាត់ដែលបានផ្លាស់ទី",
          "caption": "មុខកាត់បានផ្លាស់ទីតាមកន្លែងជីក។ របារ [បង្វិល] បង្វិលទិសប្លង់។"
        },
        {
          "title": "ចុច [រក្សាទុក]",
          "caption": "មុខកាត់ដែលបានកែ មានចំណុចពណ៌ទឹកក្រូចនៅក្បែរឈ្មោះ ហើយ [រក្សាទុក] ត្រូវបានបើក។ ចុច [រក្សាទុក]។"
        },
        {
          "title": "ពិនិត្យការរក្សាទុក",
          "caption": "បានរក្សាទុកហើយ។ ចំណុចពណ៌ទឹកក្រូចបាត់ ហើយការកែសម្រួលបិទ។ មុនរក្សាទុក [កំណត់ឡើងវិញ] ត្រឡប់ទៅរាងដែលបានរក្សាទុកចុងក្រោយ ហើយពេលកែសម្រួល អាចប្រើ [មិនធ្វើវិញ] និង [ធ្វើឡើងវិញ]។"
        }
      ]
    },
    "t-vector": {
      "title": "វ៉ិចទ័រ",
      "note": "ក្រៅពីរយៈទទឹង/រយៈបណ្ដោយ អាចបញ្ចូលជា [កូអរដោនេ X/Y] (ប្រព័ន្ធកូអរដោនេគម្រោង) ផងដែរ។ [បង្ហាញលើផែនទី] នៅខាងលើផ្ទាំង លាក់ ឬបង្ហាញវ៉ិចទ័រទាំងអស់ក្នុងពេលតែមួយ។",
      "steps": [
        {
          "title": "បើក [VECTOR]",
          "caption": "ចុច [VECTOR] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "ចុច [បង្កើតដោយបញ្ចូលកូអរដោនេ]",
          "caption": "នេះជាផ្ទាំង [វ៉ិចទ័រ]។ ចុច [បង្កើតដោយបញ្ចូលកូអរដោនេ]។"
        },
        {
          "title": "បញ្ចូលឈ្មោះ",
          "caption": "ផ្ទាំង [បង្កើតវ៉ិចទ័រ] បើកឡើង។ បញ្ចូលឈ្មោះ។"
        },
        {
          "title": "ជ្រើស [ស៊ីឡាំង]",
          "caption": "ជ្រើសរាង (បន្ទាត់ ស៊ីឡាំង សសរការេ)។ ចុច [ស៊ីឡាំង]។"
        },
        {
          "title": "បញ្ចូលកាំ",
          "caption": "បញ្ចូល [កាំ (m)]។ សម្រាប់សសរការេ បញ្ចូល [ជ្រុង (m)]។"
        },
        {
          "title": "បញ្ចូលកូអរដោនេ",
          "caption": "បញ្ចូលរយៈទទឹង រយៈបណ្ដោយ និងកម្ពស់ (m) សម្រាប់ចំណុចនីមួយៗ។ កម្ពស់គឺកម្ពស់ពីនីវ៉ូទឹកសមុទ្រ ហើយ [បន្ថែមចំណុច] បន្ថែមចំណុច (2 ដល់ 100)។"
        },
        {
          "title": "ចុច [បង្កើត]",
          "caption": "ចុច [បង្កើត]។"
        },
        {
          "title": "មើលស៊ីឡាំងដែលបានគូរ",
          "caption": "វ៉ិចទ័របន្ថែមចូលបញ្ជី ហើយស៊ីឡាំងត្រូវបានគូរក្នុងកន្លែងជីក ក្នុងទិដ្ឋភាព 3D។"
        },
        {
          "title": "ពង្រីកវ៉ិចទ័រ",
          "caption": "ចុចវ៉ិចទ័រ ដើម្បីពង្រីក។"
        },
        {
          "title": "ចុច [មុខកាត់កែង]",
          "caption": "កែឈ្មោះ រាង កាំ ពណ៌ និងកំណត់ចំណាំក្នុង [ព័ត៌មាន] និងកូអរដោនេក្នុង [បញ្ជីកូអរដោនេ] រួច [រក្សាទុក]។ ចុច [មុខកាត់កែង]។"
        },
        {
          "title": "បញ្ចូលប្រវែងបន្ទាត់កាត់",
          "caption": "ផ្ទាំង [មុខកាត់កែង] បើកឡើង។ ទីតាំងកាត់ (ចម្ងាយពីចំណុចចាប់ផ្ដើម) ត្រូវបានដាក់នៅកណ្ដាល។ ប្ដូរ [ប្រវែងបន្ទាត់កាត់ (m)] ទៅ 8 m។"
        },
        {
          "title": "ចុច [យល់ព្រម]",
          "caption": "ចុច [យល់ព្រម]។"
        },
        {
          "title": "មើលក្រាហ្វមុខកាត់",
          "caption": "បន្ទាត់កាត់ត្រូវបានគូរ កាមេរ៉ាផ្លាស់ទីទៅខាងលើវា ហើយក្រាហ្វមុខកាត់បើកនៅខាងក្រោម។ មុខកាត់ស៊ីឡាំងត្រូវបានគូរលើមុខកាត់ម៉ូដែល ដើម្បីប្រៀបធៀបបំពង់គម្រោង និងទីតាំងបំពង់ពិត។"
        }
      ]
    },
    "t-members": {
      "title": "កម្មករដែលបានតភ្ជាប់ និងតំបន់ហាមឃាត់",
      "steps": [
        {
          "title": "ចុចជួរកម្មករ",
          "caption": "នេះជាអេក្រង់ស្ថានភាពការងារ។ ផ្ទាំង [MEMBERS] (កម្មករដែលបានតភ្ជាប់) បង្ហាញអ្នកចូលរួមគម្រោង ហើយអ្នកដែលកំពុងផ្ញើទីតាំងពីកម្មវិធីទូរស័ព្ទ បង្ហាញជាម្ជុលលើផែនទី។ ចុចជួរទីពីរ។"
        },
        {
          "title": "ពិនិត្យកាត",
          "caption": "ផែនទីផ្លាស់ទៅទីតាំងអ្នកនោះ ហើយកាតមួយបើកឡើង។ វាបង្ហាញតួនាទី របាយការណ៍ទីតាំងចុងក្រោយ ភាពត្រឹមត្រូវ GPS និងស្ថានភាពការបំពាន (ឥឡូវ [ធម្មតា])។"
        },
        {
          "title": "ចុច [ZONES]",
          "caption": "យើងនឹងកំណត់កន្លែងជីកដែលអ្នកនោះកំពុងនៅ ជាតំបន់ហាមឃាត់។ ចុច [ZONES] នៅរបារខាងឆ្វេង។"
        },
        {
          "title": "ចុច [គូរតំបន់ហាមឃាត់ថ្មី]",
          "caption": "នេះជា [គ្រប់គ្រងតំបន់ហាមឃាត់]។ តំបន់នីមួយៗមានកុងតាក់បើក/បិទ ហើយម៉ឺនុយ ⋯ ប្ដូរឈ្មោះ ឬលុប។ ចុច [គូរតំបន់ហាមឃាត់ថ្មី]។"
        },
        {
          "title": "ដាក់ចំណុចកំពូលទីមួយ",
          "caption": "ការណែនាំការគូរបង្ហាញឡើង។ ដាក់ចំណុចកំពូលទីមួយជុំវិញកន្លែងជីក។"
        },
        {
          "title": "ដាក់ចំណុចកំពូលទីពីរ",
          "caption": "ដាក់ចំណុចកំពូលទីពីរ។"
        },
        {
          "title": "ដាក់ចំណុចកំពូលទីបី",
          "caption": "ដាក់ចំណុចកំពូលទីបី។"
        },
        {
          "title": "ចុចទ្វេដងលើចំណុចកំពូលចុងក្រោយ",
          "caption": "ចុចទ្វេដងដើម្បីដាក់ចំណុចកំពូលចុងក្រោយ ហើយបញ្ចប់ការគូរ។"
        },
        {
          "title": "បញ្ចូលឈ្មោះតំបន់",
          "caption": "ផ្ទាំង [ឈ្មោះតំបន់ហាមឃាត់ថ្មី] បើកឡើង។ បញ្ចូលឈ្មោះតំបន់។"
        },
        {
          "title": "ចុច [បញ្ជាក់]",
          "caption": "ចុច [បញ្ជាក់]។"
        },
        {
          "title": "ពិនិត្យការជូនដំណឹងពីការបំពាន",
          "caption": "តំបន់ត្រូវបានបង្កើត ហើយការជូនដំណឹងពីការបំពានបង្ហាញឡើងសម្រាប់កម្មករដែលនៅក្នុងតំបន់នោះ។"
        },
        {
          "title": "ពិនិត្យតំបន់ថ្មី",
          "caption": "តំបន់ត្រូវបានបន្ថែមទៅបញ្ជី ហើយគូរលើផែនទី។ ម្ជុលរបស់កម្មករនៅក្នុងតំបន់។"
        },
        {
          "title": "ចុច [MEMBERS]",
          "caption": "ពិនិត្យក្នុងបញ្ជីកម្មករផងដែរ។ ចុច [MEMBERS]។"
        },
        {
          "title": "ពិនិត្យជួរពណ៌ក្រហម",
          "caption": "ជួររបស់កម្មករនោះប្រែជាពណ៌ក្រហម ហើយមាន [បំពាន] និងឈ្មោះតំបន់។ ស្ថានភាពការបំពាននៅលើកាតដែលកំពុងបើក ក៏ប្ដូរទៅ [បំពាន] ដែរ។"
        }
      ]
    },
    "t-equip": {
      "title": "ការដាក់ឧបករណ៍",
      "note": "ឧបករណ៍ដែលលាក់ពីផែនទីដោយរូបភ្នែកក្នុងបញ្ជី មិនត្រូវបានរាប់ក្នុងការត្រួតគ្នានៃកាំការងារ (គ្រោះថ្នាក់) ទេ។",
      "steps": [
        {
          "title": "ចុច [EQUIP]",
          "caption": "នៅរបារខាងឆ្វេងនៃអេក្រង់ស្ថានភាពការងារ ចុច [EQUIP]។"
        },
        {
          "title": "ចុច [បន្ថែមឧបករណ៍]",
          "caption": "ផ្ទាំងឧបករណ៍បង្ហាញឧបករណ៍ដែលបានដាក់រួច។ ចុច [បន្ថែមឧបករណ៍]។"
        },
        {
          "title": "ជ្រើស [ម៉ាស៊ីនជីក]",
          "caption": "ប្រភេទ (លើក និងកម្ពស់ ការងារដី និងដឹកជញ្ជូន សំណង់បណ្ដោះអាសន្ន សម្ភារៈ កម្លាំងពលកម្ម) និងកាតប្រភេទ បើកឡើងលើផែនទី។ ចុច [ម៉ាស៊ីនជីក]។"
        },
        {
          "title": "កំណត់លក្ខណៈ ហើយចុច [ដាក់]",
          "caption": "ក្នុងផ្ទាំងដាក់ កំណត់ឈ្មោះ លក្ខណៈបច្ចេកទេសគោល ប្រវែង ទទឹង កម្ពស់ កាំការងារ និងពណ៌កាំ ហើយចុច [ដាក់]។"
        },
        {
          "title": "ចុចកន្លែងដែលត្រូវដាក់",
          "caption": "កាតប្រភេទប្រែជាស្រអាប់ ហើយចាប់ផ្ដើមការដាក់។ ចុចក្បែរម៉ាស៊ីនជីកទីមួយលើផែនទី។ ចុចស្ដាំដើម្បីបោះបង់។"
        },
        {
          "title": "ពិនិត្យកាំការងារដែលត្រួតគ្នា",
          "caption": "ម៉ាស៊ីនជីកទីពីរត្រូវបានដាក់។ កន្លែងដែលកាំការងារទាំងពីរត្រួតគ្នាត្រូវបានលាបពណ៌ក្រហម ហើយសញ្ញាគ្រោះថ្នាក់ (!) បង្ហាញលើជួរទាំងពីរក្នុងបញ្ជី។"
        },
        {
          "title": "ពង្រីកជួរម៉ាស៊ីនជីកថ្មី",
          "caption": "យើងនឹងផ្លាស់វាកុំឱ្យកាំត្រួតគ្នា។ ចុចប៊ូតុងពង្រីកនៅខាងឆ្វេងជួរម៉ាស៊ីនជីកថ្មី។"
        },
        {
          "title": "ចុចផ្ទាំង [ទីតាំង·ទិស]",
          "caption": "មានផ្ទាំង [លក្ខណៈ] [ទីតាំង·ទិស] និង [ផ្លូវធ្វើដំណើរ]។ ចុច [ទីតាំង·ទិស]។"
        },
        {
          "title": "ចុច [ផ្លាស់ទីលើផែនទី]",
          "caption": "ឌីសទិសដៅមុខ និងរយៈបណ្ដោយ រយៈទទឹង កម្ពស់ បង្ហាញឡើង។ ចុច [ផ្លាស់ទីលើផែនទី]។"
        },
        {
          "title": "ចុចកន្លែងថ្មី",
          "caption": "ប៊ូតុងប្ដូរទៅ [កំពុងផ្លាស់ទី]។ ចុចកន្លែងលើផែនទីដែលកាំការងារមិនត្រួតគ្នា។"
        },
        {
          "title": "ពិនិត្យទីតាំងថ្មី",
          "caption": "ម៉ាស៊ីនជីកផ្លាស់ទៅទីនោះ ហើយរយៈបណ្ដោយ និងរយៈទទឹងប្ដូរ។ កាំការងារលែងត្រួតគ្នា ដូច្នេះសញ្ញាគ្រោះថ្នាក់បាត់។"
        }
      ]
    },
    "t-route": {
      "title": "ការក្លែងធ្វើផ្លូវធ្វើដំណើររបស់ឧបករណ៍",
      "note": "ការត្រួតគ្នាដែលប្រែប្រួលពេលចាក់ បង្ហាញតែលើផែនទី ហើយសញ្ញាគ្រោះថ្នាក់ក្នុងបញ្ជីរាប់តាមទីតាំងដែលបានរក្សាទុក។",
      "steps": [
        {
          "title": "ពង្រីកជួរម៉ាស៊ីនជីកទីមួយ",
          "caption": "នេះជាផ្ទាំងឧបករណ៍។ ម៉ាស៊ីនជីកទីពីរមានផ្លូវធ្វើដំណើររួចហើយ។ ចុចប៊ូតុងពង្រីកនៅខាងឆ្វេងជួរម៉ាស៊ីនជីកទីមួយ។"
        },
        {
          "title": "ចុចផ្ទាំង [ផ្លូវធ្វើដំណើរ]",
          "caption": "ចុចផ្ទាំង [ផ្លូវធ្វើដំណើរ]។"
        },
        {
          "title": "ចុច [គូរផ្លូវធ្វើដំណើរ]",
          "caption": "[មិនទាន់មានផ្លូវធ្វើដំណើរទេ] បង្ហាញ។ ចុច [គូរផ្លូវធ្វើដំណើរ]។"
        },
        {
          "title": "ដាក់ចំណុចបន្ទាប់",
          "caption": "ទីតាំងឧបករណ៍ក្លាយជាចំណុចទីមួយ ([ចំណុច] 1)។ ចុចចំណុចបន្ទាប់លើផែនទី។"
        },
        {
          "title": "ចុចទ្វេដងលើចំណុចចុងក្រោយ",
          "caption": "ចុចទ្វេដងដើម្បីដាក់ចំណុចចុងក្រោយ ហើយបញ្ចប់។"
        },
        {
          "title": "ចុច [ចាក់ផ្លូវធ្វើដំណើរ]",
          "caption": "ផ្លូវត្រូវបានរក្សាទុក ហើយ [ការក្លែងធ្វើផ្លូវ] បង្ហាញរបារចាក់ ការចាក់ដដែលៗ ល្បឿន និងចំណុច ចម្ងាយ រយៈពេលប៉ាន់ស្មាន។ ចុចប៊ូតុងចាក់។"
        },
        {
          "title": "ពង្រីកជួរម៉ាស៊ីនជីកទីពីរ",
          "caption": "ម៉ាស៊ីនជីកទីមួយផ្លាស់ទីតាមផ្លូវ។ ដើម្បីផ្លាស់ទីទាំងពីរជាមួយគ្នា ពង្រីកជួរម៉ាស៊ីនជីកទីពីរ។"
        },
        {
          "title": "ចុចផ្ទាំង [ផ្លូវធ្វើដំណើរ]",
          "caption": "ចុចផ្ទាំង [ផ្លូវធ្វើដំណើរ] របស់ម៉ាស៊ីនជីកទីពីរ។"
        },
        {
          "title": "ចុច [ចាក់ផ្លូវធ្វើដំណើរ]",
          "caption": "ចុចប៊ូតុងចាក់របស់ម៉ាស៊ីនជីកទីពីរ។"
        },
        {
          "title": "មើលពេលត្រួតគ្នា",
          "caption": "ម៉ាស៊ីនជីកទាំងពីរផ្លាស់ទីព្រមគ្នា។ ពេលកាំការងារត្រួតគ្នា កន្លែងត្រួតគ្នាត្រូវបានលាបពណ៌ក្រហម ហើយសញ្ញាគ្រោះថ្នាក់ (!) បង្ហាញលើស្លាកឈ្មោះ។"
        }
      ]
    },
    "t-ewzone": {
      "title": "បរិមាណការងារដីតាមតំបន់ក្នុង 3D",
      "note": "បរិមាណត្រូវបានគណនាពីក្រឡាទាំងអស់ក្នុងតំបន់ ហើយគំនូរផ្នែកកាត់ក្នុង [របៀបគណនា] ជាចន្លោះឧទាហរណ៍នៃការគណនានោះ។",
      "steps": [
        {
          "title": "ចុច [＋ គូរតំបន់]",
          "caption": "នេះជាអេក្រង់ការងារដី។ ក្នុង [Voxel 3D] បរិមាណការងារដីត្រូវបានគណនាដោយបូកប្លង់ទាំងអស់ដែលឆ្លងកាត់តំបន់ដែលគូរលើម៉ូដែល 3D។ ចុច [＋ គូរតំបន់]។"
        },
        {
          "title": "ដាក់កំពូលទីមួយ",
          "caption": "ផ្ទាំងបង្ហាញ [កំពុងគូរតំបន់។ ចុចពីរដងដើម្បីបញ្ចប់ការគូរ។]។ ដាក់កំពូលទីមួយជុំវិញកន្លែងជីក។"
        },
        {
          "title": "ដាក់កំពូលទីពីរ",
          "caption": "ដាក់កំពូលទីពីរ។"
        },
        {
          "title": "ដាក់កំពូលទីបី",
          "caption": "ដាក់កំពូលទីបី។"
        },
        {
          "title": "ចុចពីរដងលើកំពូលចុងក្រោយ",
          "caption": "ចុចពីរដងលើកំពូលចុងក្រោយ ដើម្បីបញ្ចប់ការគូរ។"
        },
        {
          "title": "ចុច [គណនា]",
          "caption": "វាត្រូវបានរក្សាទុកជា [តំបន់ 1] បន្ថែមទៅបញ្ជី ហើយលាបពណ៌លើម៉ូដែល។ [ប្លង់ដែលបានប្រើក្នុងតំបន់ 1] បង្ហាញប្លង់ដែលតំបន់ឆ្លងកាត់។ ចុច [គណនា] នៅកាត [បរិមាណការងារដី]។"
        },
        {
          "title": "ពង្រីក [បញ្ជីស៊េរីពេលវេលាដែលបានគណនា]",
          "caption": "ពេលគណនារួច ការគ្របដណ្ដប់ និង [របៀបគណនា]·[មើលតារាងដីសំណង់] បង្ហាញឡើង។ ពង្រីក [បញ្ជីស៊េរីពេលវេលាដែលបានគណនា 2/2]។"
        },
        {
          "title": "ដោះធីក [2024-01-25]",
          "caption": "ស៊េរីពេលវេលាដែលបានរាប់ក្នុងការគណនាត្រូវបានបង្ហាញ។ 01-25 ថតក្រោយពេលកន្លែងជីកត្រូវបានចាក់បំពេញវិញ ដូច្នេះដកវាចេញ។ ដោះធីក [2024-01-25]។"
        },
        {
          "title": "ចុច [គណនាឡើងវិញ]",
          "caption": "[បានដកចេញពីការគណនា] បង្ហាញ រួមជាមួយសេចក្ដីជូនដំណឹងថាស៊េរីពេលវេលាដែលរាប់បញ្ចូលបានផ្លាស់ប្ដូរ និង [គណនាឡើងវិញ]។ ចុច [គណនាឡើងវិញ]។"
        },
        {
          "title": "ចុច [របៀបគណនា]",
          "caption": "បញ្ជីប្ដូរទៅ [1/2] ហើយសេចក្ដីជូនដំណឹងបាត់។ ចុច [របៀបគណនា]។"
        },
        {
          "title": "រំកិលចុះក្រោមក្នុងប្រអប់",
          "caption": "នេះជាប្រអប់ [របៀបគណនា]។ គំនូរផ្នែកកាត់នៃចន្លោះឧទាហរណ៍ បង្ហាញរបៀបរាប់ភាពខុសគ្នារវាងផ្ទៃពីរតាមក្រឡានីមួយៗ និងបរិមាណគម្រោង (ដីដើម→កម្ពស់គម្រោង)។ រំកិលចុះក្រោមក្នុងប្រអប់។"
        },
        {
          "title": "ពិនិត្យដែលបានធ្វើ·នៅសល់",
          "caption": "តាមស៊េរីពេលវេលានីមួយៗ គំនូរផ្នែកកាត់នៃបរិមាណដែលបានធ្វើ (ដីដើម→ដីដ្រូន) និងនៅសល់ (ដីដ្រូន→កម្ពស់គម្រោង) បង្ហាញជាមួយអត្រាវឌ្ឍនភាព។ គម្រោង = ដែលបានធ្វើ + នៅសល់។"
        }
      ]
    },
    "t-ewtable": {
      "title": "តារាងដីសំណង់",
      "note": "បើមានតំបន់ច្រើន តំបន់នីមួយៗមានតារាងរៀងៗខ្លួន។ អូសតារាងដើម្បីប្ដូរលំដាប់ ហើយជ្រើសតំបន់ដែលត្រូវដាក់ក្នុងឯកសារដោយ [បញ្ចូលក្នុងការនាំចេញ CSV]។",
      "steps": [
        {
          "title": "ចុច [មើលតារាងដីសំណង់]",
          "caption": "តំបន់ 1 ត្រូវបានជ្រើស។ ចុច [មើលតារាងដីសំណង់] នៅកាត [បរិមាណការងារដី]។"
        },
        {
          "title": "អូសរបារ [តម្លាភាព]",
          "caption": "នេះជាប្រអប់ [តារាងដីសំណង់]។ បង្ហាញការកាត់ (ដី) និងការបំពេញ (Subgrade·ផ្លូវ) ជាបរិមាណផែនការ·បរិមាណដីដែលសល់·សរុបប្រចាំថ្ងៃ និងបរិមាណដែលបានធ្វើតាមថ្ងៃថត។ អូសរបារ [តម្លាភាព] ទៅស្ដាំ។"
        },
        {
          "title": "មើលម៉ូដែលក្រោមតារាង",
          "caption": "តារាងក្លាយជាថ្លា ហើយម៉ូដែល 3D និងតំបន់នៅខាងក្រោមបង្ហាញជាមួយគ្នា។ អូសក្បាលប្រអប់ដើម្បីផ្លាស់ទី ហើយទាញយកតារាងជាឯកសារដោយ [នាំចេញ CSV (តំបន់ 1)]។"
        }
      ]
    },
    "t-linear": {
      "title": "ការងារដីផ្អែកលើខ្សែបន្ទាត់",
      "note": "ការកំណត់ផ្នែកកាត់·ក្រាហ្វ·តារាងបរិមាណផ្នែកឆ្លង ដូចគ្នានឹង <a href=\"#c6\">06 ក្រាហ្វផ្នែកកាត់</a>។",
      "steps": [
        {
          "title": "ចុច [ផ្អែកលើខ្សែបន្ទាត់]",
          "caption": "[ផ្អែកលើខ្សែបន្ទាត់] មើលផ្នែកកាត់ និងបរិមាណតាមចំណុចវាស់នីមួយៗ ដោយខ្សែបន្ទាត់តែមួយ។ ចុច [ផ្អែកលើខ្សែបន្ទាត់] នៅខាងលើផ្ទាំងការងារដី។"
        },
        {
          "title": "ចុច [បើកក្រាហ្វផ្នែក]",
          "caption": "បញ្ជីស្រទាប់លីនេអ៊ែរ និងស៊េរីពេលវេលាដែលប្រើផ្ទៃស្ថានភាពបច្ចុប្បន្នដើម្បីគណនាផ្នែកកាត់·តារាងបរិមាណ បង្ហាញឡើង។ ចុចរូបតំណាងក្រាហ្វ ([បើកក្រាហ្វផ្នែក]) នៅលើជួរ។"
        },
        {
          "title": "ចុច [ពិនិត្យ] ក្នុង [ផ្នែកឆ្លង]",
          "caption": "ផ្លូវ និងចំណុចវាស់បង្ហាញលើម៉ូដែល ហើយផ្ទាំងកំណត់ផ្នែកកាត់បើកឡើង។ ចុច [ពិនិត្យ] ក្នុង [ផ្នែកឆ្លង]។"
        },
        {
          "title": "អូសផ្លូវទៅកណ្ដាល",
          "caption": "បន្ទាត់ផ្នែកឆ្លងត្រូវបានគូរតាមចំណុចវាស់នីមួយៗ ហើយក្រាហ្វផ្នែកឆ្លងនៃចំណុចវាស់ទីមួយបើកនៅខាងក្រោម។ អូសដោយប៊ូតុងឆ្វេង ដើម្បីផ្លាស់ផ្លូវទៅកណ្ដាល កុំឱ្យក្រាហ្វបាំង។"
        },
        {
          "title": "ផ្អៀងដោយប៊ូតុងស្ដាំ",
          "caption": "នេះជាទិដ្ឋភាពមើលពីលើចុះក្រោមត្រង់។ សង្កត់ប៊ូតុងស្ដាំ ហើយអូសឡើងលើ ដើម្បីផ្អៀងម៉ូដែល។"
        },
        {
          "title": "ចុចបន្ទាត់ផ្នែកឆ្លង 0+060",
          "caption": "មើលម៉ូដែលពីទិសទ្រេត។ ចុចបន្ទាត់ផ្នែកឆ្លង 0+060 លើម៉ូដែល។"
        },
        {
          "title": "ចុច [បន្ថែមទៀត]",
          "caption": "ក្រាហ្វប្ដូរទៅផ្នែកឆ្លងនៃចំណុចវាស់នោះ (060)។ ចុច [បន្ថែមទៀត]។"
        },
        {
          "title": "ចុច [តារាងបរិមាណ]",
          "caption": "ចុច [តារាងបរិមាណ]។"
        },
        {
          "title": "មើលតារាងបរិមាណ",
          "caption": "នេះជាប្រអប់ [តារាងបរិមាណផ្នែកឆ្លង]។ បង្ហាញកម្ពស់ដីដើម·កម្ពស់គម្រោង·កម្ពស់បច្ចុប្បន្ននៃចំណុចវាស់នេះ និងផ្ទៃបំពេញ·កាត់ ជាគម្រោង (ខៀវ)·វឌ្ឍនភាព (បៃតង)។"
        }
      ]
    },

  },
  "mapping": {
    "gcpPath": "ការប្រើ GCP (Ground Control Point) ធ្វើឱ្យភាពត្រឹមត្រូវនៃទីតាំងប្រសើរឡើង។ បញ្ចូលឯកសារ GCP (csv·txt·xlsx) នៅជួរ GCP ក្នុង $t(projects:timeSeries.mappingInfo) រួចស្នើសុំ Mapping។",
    "autoDetect": "ប្រសិនបើ [$t(projects:timeSeries.gcpAutoDetect)] បង្ហាញនៅជួរ GCP វគ្គដែលថតដោយដាក់សញ្ញាសម្គាល់ស្តង់ដាររបស់ DroneSquare នឹងត្រូវធ្វើ Mapping ដោយស្វ័យប្រវត្តិ ដោយមិនចាំបាច់មានមនុស្សធ្វើ។ សញ្ញាសម្គាល់ត្រូវរៀបចំមុនពេលថត ដូច្នេះសូមពិនិត្យមើលមគ្គុទ្ទេសក៍ខាងក្រោមជាមុនសិន។",
    "ownerOnly": "មានតែម្ចាស់គម្រោងប៉ុណ្ណោះដែលអាចស្នើសុំការគូសផែនទីបាន។",
    "processingTime": "រយៈពេលដំណើរការអាស្រ័យលើចំនួនរូបថត និងវិធីដំណើរការ (ស្វ័យប្រវត្តិ ឬដោយបុគ្គលិក)។"
  }
} as const;

export default landingManual;
